(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('isomorphic-fetch')) :
	typeof define === 'function' && define.amd ? define(['exports', 'isomorphic-fetch'], factory) :
	(global = global || self, factory(global['@zola-helpers/client'] = {}, global.fetch));
}(this, (function (exports, fetch) { 'use strict';

	fetch = fetch && fetch.hasOwnProperty('default') ? fetch['default'] : fetch;

	var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}

	var _global = createCommonjsModule(function (module) {
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
	});

	var _core = createCommonjsModule(function (module) {
	var core = module.exports = { version: '2.6.10' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
	});
	var _core_1 = _core.version;

	var _aFunction = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};

	// optional / simple context binding

	var _ctx = function (fn, that, length) {
	  _aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};

	var _isObject = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};

	var _anObject = function (it) {
	  if (!_isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};

	var _fails = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};

	// Thank's IE8 for his funny defineProperty
	var _descriptors = !_fails(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});

	var document$1 = _global.document;
	// typeof document.createElement is 'object' in old IE
	var is = _isObject(document$1) && _isObject(document$1.createElement);
	var _domCreate = function (it) {
	  return is ? document$1.createElement(it) : {};
	};

	var _ie8DomDefine = !_descriptors && !_fails(function () {
	  return Object.defineProperty(_domCreate('div'), 'a', { get: function () { return 7; } }).a != 7;
	});

	// 7.1.1 ToPrimitive(input [, PreferredType])

	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	var _toPrimitive = function (it, S) {
	  if (!_isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !_isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !_isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};

	var dP = Object.defineProperty;

	var f = _descriptors ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  _anObject(O);
	  P = _toPrimitive(P, true);
	  _anObject(Attributes);
	  if (_ie8DomDefine) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};

	var _objectDp = {
		f: f
	};

	var _propertyDesc = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};

	var _hide = _descriptors ? function (object, key, value) {
	  return _objectDp.f(object, key, _propertyDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};

	var hasOwnProperty = {}.hasOwnProperty;
	var _has = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};

	var PROTOTYPE = 'prototype';

	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? _core : _core[name] || (_core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? _global : IS_STATIC ? _global[name] : (_global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && _has(exports, key)) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? _ctx(out, _global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? _ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) _hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	var _export = $export;

	var toString = {}.toString;

	var _cof = function (it) {
	  return toString.call(it).slice(8, -1);
	};

	// fallback for non-array-like ES3 and non-enumerable old V8 strings

	// eslint-disable-next-line no-prototype-builtins
	var _iobject = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return _cof(it) == 'String' ? it.split('') : Object(it);
	};

	// 7.2.1 RequireObjectCoercible(argument)
	var _defined = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};

	// to indexed object, toObject with fallback for non-array-like ES3 strings


	var _toIobject = function (it) {
	  return _iobject(_defined(it));
	};

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	var _toInteger = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};

	// 7.1.15 ToLength

	var min = Math.min;
	var _toLength = function (it) {
	  return it > 0 ? min(_toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};

	var max = Math.max;
	var min$1 = Math.min;
	var _toAbsoluteIndex = function (index, length) {
	  index = _toInteger(index);
	  return index < 0 ? max(index + length, 0) : min$1(index, length);
	};

	// false -> Array#indexOf
	// true  -> Array#includes



	var _arrayIncludes = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = _toIobject($this);
	    var length = _toLength(O.length);
	    var index = _toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};

	var _library = true;

	var _shared = createCommonjsModule(function (module) {
	var SHARED = '__core-js_shared__';
	var store = _global[SHARED] || (_global[SHARED] = {});

	(module.exports = function (key, value) {
	  return store[key] || (store[key] = value !== undefined ? value : {});
	})('versions', []).push({
	  version: _core.version,
	  mode:  'pure' ,
	  copyright: '© 2019 Denis Pushkarev (zloirock.ru)'
	});
	});

	var id = 0;
	var px = Math.random();
	var _uid = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};

	var shared = _shared('keys');

	var _sharedKey = function (key) {
	  return shared[key] || (shared[key] = _uid(key));
	};

	var arrayIndexOf = _arrayIncludes(false);
	var IE_PROTO = _sharedKey('IE_PROTO');

	var _objectKeysInternal = function (object, names) {
	  var O = _toIobject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) _has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (_has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};

	// IE 8- don't enum bug keys
	var _enumBugKeys = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)



	var _objectKeys = Object.keys || function keys(O) {
	  return _objectKeysInternal(O, _enumBugKeys);
	};

	var f$1 = Object.getOwnPropertySymbols;

	var _objectGops = {
		f: f$1
	};

	var f$2 = {}.propertyIsEnumerable;

	var _objectPie = {
		f: f$2
	};

	// 7.1.13 ToObject(argument)

	var _toObject = function (it) {
	  return Object(_defined(it));
	};

	// 19.1.2.1 Object.assign(target, source, ...)






	var $assign = Object.assign;

	// should work with symbols and should have deterministic property order (V8 bug)
	var _objectAssign = !$assign || _fails(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = _toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = _objectGops.f;
	  var isEnum = _objectPie.f;
	  while (aLen > index) {
	    var S = _iobject(arguments[index++]);
	    var keys = getSymbols ? _objectKeys(S).concat(getSymbols(S)) : _objectKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) {
	      key = keys[j++];
	      if (!_descriptors || isEnum.call(S, key)) T[key] = S[key];
	    }
	  } return T;
	} : $assign;

	// 19.1.3.1 Object.assign(target, source)


	_export(_export.S + _export.F, 'Object', { assign: _objectAssign });

	var assign = _core.Object.assign;

	var assign$1 = assign;

	var LOGIN_REQUEST = 'zola/auth/LOGGED_IN';
	var LOGIN_SUCCESS = 'zola/auth/LOGIN_SUCCESS';
	var LOGIN_FAILURE = 'zola/auth/LOGIN_FAILURE';
	var LOGOUT = 'zola/auth/LOGOUT';

	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	_export(_export.S + _export.F * !_descriptors, 'Object', { defineProperty: _objectDp.f });

	var $Object = _core.Object;
	var defineProperty = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};

	var defineProperty$1 = defineProperty;

	var _objectDps = _descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
	  _anObject(O);
	  var keys = _objectKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) _objectDp.f(O, P = keys[i++], Properties[P]);
	  return O;
	};

	// 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	_export(_export.S + _export.F * !_descriptors, 'Object', { defineProperties: _objectDps });

	var $Object$1 = _core.Object;
	var defineProperties = function defineProperties(T, D) {
	  return $Object$1.defineProperties(T, D);
	};

	var defineProperties$1 = defineProperties;

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)

	var hiddenKeys = _enumBugKeys.concat('length', 'prototype');

	var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return _objectKeysInternal(O, hiddenKeys);
	};

	var _objectGopn = {
		f: f$3
	};

	// all object keys, includes non-enumerable and symbols



	var Reflect = _global.Reflect;
	var _ownKeys = Reflect && Reflect.ownKeys || function ownKeys(it) {
	  var keys = _objectGopn.f(_anObject(it));
	  var getSymbols = _objectGops.f;
	  return getSymbols ? keys.concat(getSymbols(it)) : keys;
	};

	var gOPD = Object.getOwnPropertyDescriptor;

	var f$4 = _descriptors ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = _toIobject(O);
	  P = _toPrimitive(P, true);
	  if (_ie8DomDefine) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (_has(O, P)) return _propertyDesc(!_objectPie.f.call(O, P), O[P]);
	};

	var _objectGopd = {
		f: f$4
	};

	var _createProperty = function (object, index, value) {
	  if (index in object) _objectDp.f(object, index, _propertyDesc(0, value));
	  else object[index] = value;
	};

	// https://github.com/tc39/proposal-object-getownpropertydescriptors






	_export(_export.S, 'Object', {
	  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	    var O = _toIobject(object);
	    var getDesc = _objectGopd.f;
	    var keys = _ownKeys(O);
	    var result = {};
	    var i = 0;
	    var key, desc;
	    while (keys.length > i) {
	      desc = getDesc(O, key = keys[i++]);
	      if (desc !== undefined) _createProperty(result, key, desc);
	    }
	    return result;
	  }
	});

	var getOwnPropertyDescriptors = _core.Object.getOwnPropertyDescriptors;

	var getOwnPropertyDescriptors$1 = getOwnPropertyDescriptors;

	// most Object methods by ES6 should accept primitives



	var _objectSap = function (KEY, exec) {
	  var fn = (_core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  _export(_export.S + _export.F * _fails(function () { fn(1); }), 'Object', exp);
	};

	// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)

	var $getOwnPropertyDescriptor = _objectGopd.f;

	_objectSap('getOwnPropertyDescriptor', function () {
	  return function getOwnPropertyDescriptor(it, key) {
	    return $getOwnPropertyDescriptor(_toIobject(it), key);
	  };
	});

	var $Object$2 = _core.Object;
	var getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  return $Object$2.getOwnPropertyDescriptor(it, key);
	};

	var getOwnPropertyDescriptor$1 = getOwnPropertyDescriptor;

	var _redefine = _hide;

	var _meta = createCommonjsModule(function (module) {
	var META = _uid('meta');


	var setDesc = _objectDp.f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !_fails(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!_isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!_has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!_has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !_has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};
	});
	var _meta_1 = _meta.KEY;
	var _meta_2 = _meta.NEED;
	var _meta_3 = _meta.fastKey;
	var _meta_4 = _meta.getWeak;
	var _meta_5 = _meta.onFreeze;

	var _wks = createCommonjsModule(function (module) {
	var store = _shared('wks');

	var Symbol = _global.Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';

	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : _uid)('Symbol.' + name));
	};

	$exports.store = store;
	});

	var def = _objectDp.f;

	var TAG = _wks('toStringTag');

	var _setToStringTag = function (it, tag, stat) {
	  if (it && !_has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};

	var f$5 = _wks;

	var _wksExt = {
		f: f$5
	};

	var defineProperty$2 = _objectDp.f;
	var _wksDefine = function (name) {
	  var $Symbol = _core.Symbol || (_core.Symbol =  {} );
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty$2($Symbol, name, { value: _wksExt.f(name) });
	};

	// all enumerable object keys, includes symbols



	var _enumKeys = function (it) {
	  var result = _objectKeys(it);
	  var getSymbols = _objectGops.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = _objectPie.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};

	// 7.2.2 IsArray(argument)

	var _isArray = Array.isArray || function isArray(arg) {
	  return _cof(arg) == 'Array';
	};

	var document$2 = _global.document;
	var _html = document$2 && document$2.documentElement;

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])



	var IE_PROTO$1 = _sharedKey('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE$1 = 'prototype';

	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = _domCreate('iframe');
	  var i = _enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  _html.appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE$1][_enumBugKeys[i]];
	  return createDict();
	};

	var _objectCreate = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE$1] = _anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE$1] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO$1] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : _objectDps(result, Properties);
	};

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window

	var gOPN = _objectGopn.f;
	var toString$1 = {}.toString;

	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];

	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};

	var f$6 = function getOwnPropertyNames(it) {
	  return windowNames && toString$1.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(_toIobject(it));
	};

	var _objectGopnExt = {
		f: f$6
	};

	// ECMAScript 6 symbols shim





	var META = _meta.KEY;





















	var gOPD$1 = _objectGopd.f;
	var dP$1 = _objectDp.f;
	var gOPN$1 = _objectGopnExt.f;
	var $Symbol = _global.Symbol;
	var $JSON = _global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE$2 = 'prototype';
	var HIDDEN = _wks('_hidden');
	var TO_PRIMITIVE = _wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = _shared('symbol-registry');
	var AllSymbols = _shared('symbols');
	var OPSymbols = _shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE$2];
	var USE_NATIVE = typeof $Symbol == 'function' && !!_objectGops.f;
	var QObject = _global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE$2] || !QObject[PROTOTYPE$2].findChild;

	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = _descriptors && _fails(function () {
	  return _objectCreate(dP$1({}, 'a', {
	    get: function () { return dP$1(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD$1(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP$1(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP$1(ObjectProto, key, protoDesc);
	} : dP$1;

	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _objectCreate($Symbol[PROTOTYPE$2]);
	  sym._k = tag;
	  return sym;
	};

	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};

	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  _anObject(it);
	  key = _toPrimitive(key, true);
	  _anObject(D);
	  if (_has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!_has(it, HIDDEN)) dP$1(it, HIDDEN, _propertyDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (_has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _objectCreate(D, { enumerable: _propertyDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP$1(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  _anObject(it);
	  var keys = _enumKeys(P = _toIobject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _objectCreate(it) : $defineProperties(_objectCreate(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = _toPrimitive(key, true));
	  if (this === ObjectProto && _has(AllSymbols, key) && !_has(OPSymbols, key)) return false;
	  return E || !_has(this, key) || !_has(AllSymbols, key) || _has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor$1 = function getOwnPropertyDescriptor(it, key) {
	  it = _toIobject(it);
	  key = _toPrimitive(key, true);
	  if (it === ObjectProto && _has(AllSymbols, key) && !_has(OPSymbols, key)) return;
	  var D = gOPD$1(it, key);
	  if (D && _has(AllSymbols, key) && !(_has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN$1(_toIobject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!_has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN$1(IS_OP ? OPSymbols : _toIobject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (_has(AllSymbols, key = names[i++]) && (IS_OP ? _has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};

	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = _uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (_has(this, HIDDEN) && _has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, _propertyDesc(1, value));
	    };
	    if (_descriptors && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  _redefine($Symbol[PROTOTYPE$2], 'toString', function toString() {
	    return this._k;
	  });

	  _objectGopd.f = $getOwnPropertyDescriptor$1;
	  _objectDp.f = $defineProperty;
	  _objectGopn.f = _objectGopnExt.f = $getOwnPropertyNames;
	  _objectPie.f = $propertyIsEnumerable;
	  _objectGops.f = $getOwnPropertySymbols;

	  if (_descriptors && !_library) {
	    _redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }

	  _wksExt.f = function (name) {
	    return wrap(_wks(name));
	  };
	}

	_export(_export.G + _export.W + _export.F * !USE_NATIVE, { Symbol: $Symbol });

	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)_wks(es6Symbols[j++]);

	for (var wellKnownSymbols = _objectKeys(_wks.store), k = 0; wellKnownSymbols.length > k;) _wksDefine(wellKnownSymbols[k++]);

	_export(_export.S + _export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return _has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});

	_export(_export.S + _export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor$1,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});

	// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
	// https://bugs.chromium.org/p/v8/issues/detail?id=3443
	var FAILS_ON_PRIMITIVES = _fails(function () { _objectGops.f(1); });

	_export(_export.S + _export.F * FAILS_ON_PRIMITIVES, 'Object', {
	  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
	    return _objectGops.f(_toObject(it));
	  }
	});

	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && _export(_export.S + _export.F * (!USE_NATIVE || _fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!_isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!_isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});

	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE$2][TO_PRIMITIVE] || _hide($Symbol[PROTOTYPE$2], TO_PRIMITIVE, $Symbol[PROTOTYPE$2].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	_setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	_setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	_setToStringTag(_global.JSON, 'JSON', true);

	var getOwnPropertySymbols = _core.Object.getOwnPropertySymbols;

	var getOwnPropertySymbols$1 = getOwnPropertySymbols;

	// 19.1.2.14 Object.keys(O)



	_objectSap('keys', function () {
	  return function keys(it) {
	    return _objectKeys(_toObject(it));
	  };
	});

	var keys = _core.Object.keys;

	var keys$1 = keys;

	var $JSON$1 = _core.JSON || (_core.JSON = { stringify: JSON.stringify });
	var stringify = function stringify(it) { // eslint-disable-line no-unused-vars
	  return $JSON$1.stringify.apply($JSON$1, arguments);
	};

	var stringify$1 = stringify;

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    defineProperty$1(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }

	  return obj;
	}

	var defineProperty$3 = _defineProperty;

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);

	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }

	  return result;
	}

	var _arrayMap = arrayMap;

	// true  -> String#at
	// false -> String#codePointAt
	var _stringAt = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(_defined(that));
	    var i = _toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};

	var _iterators = {};

	var IteratorPrototype = {};

	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	_hide(IteratorPrototype, _wks('iterator'), function () { return this; });

	var _iterCreate = function (Constructor, NAME, next) {
	  Constructor.prototype = _objectCreate(IteratorPrototype, { next: _propertyDesc(1, next) });
	  _setToStringTag(Constructor, NAME + ' Iterator');
	};

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)


	var IE_PROTO$2 = _sharedKey('IE_PROTO');
	var ObjectProto$1 = Object.prototype;

	var _objectGpo = Object.getPrototypeOf || function (O) {
	  O = _toObject(O);
	  if (_has(O, IE_PROTO$2)) return O[IE_PROTO$2];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto$1 : null;
	};

	var ITERATOR = _wks('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';

	var returnThis = function () { return this; };

	var _iterDefine = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  _iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = $native || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = _objectGpo($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      _setToStringTag(IteratorPrototype, TAG, true);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if (( FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    _hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  _iterators[NAME] = $default;
	  _iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) _redefine(proto, key, methods[key]);
	    } else _export(_export.P + _export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};

	var $at = _stringAt(true);

	// 21.1.3.27 String.prototype[@@iterator]()
	_iterDefine(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});

	var _iterStep = function (done, value) {
	  return { value: value, done: !!done };
	};

	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	var es6_array_iterator = _iterDefine(Array, 'Array', function (iterated, kind) {
	  this._t = _toIobject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return _iterStep(1);
	  }
	  if (kind == 'keys') return _iterStep(0, index);
	  if (kind == 'values') return _iterStep(0, O[index]);
	  return _iterStep(0, [index, O[index]]);
	}, 'values');

	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	_iterators.Arguments = _iterators.Array;

	var TO_STRING_TAG = _wks('toStringTag');

	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');

	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = _global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) _hide(proto, TO_STRING_TAG, NAME);
	  _iterators[NAME] = _iterators.Array;
	}

	var iterator = _wksExt.f('iterator');

	var iterator$1 = iterator;

	_wksDefine('asyncIterator');

	_wksDefine('observable');

	var symbol = _core.Symbol;

	var symbol$1 = symbol;

	var _typeof_1 = createCommonjsModule(function (module) {
	function _typeof2(obj) { if (typeof symbol$1 === "function" && typeof iterator$1 === "symbol") { _typeof2 = function _typeof2(obj) { return typeof obj; }; } else { _typeof2 = function _typeof2(obj) { return obj && typeof symbol$1 === "function" && obj.constructor === symbol$1 && obj !== symbol$1.prototype ? "symbol" : typeof obj; }; } return _typeof2(obj); }

	function _typeof(obj) {
	  if (typeof symbol$1 === "function" && _typeof2(iterator$1) === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return _typeof2(obj);
	    };
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof symbol$1 === "function" && obj.constructor === symbol$1 && obj !== symbol$1.prototype ? "symbol" : _typeof2(obj);
	    };
	  }

	  return _typeof(obj);
	}

	module.exports = _typeof;
	});

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}

	var _listCacheClear = listCacheClear;

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || value !== value && other !== other;
	}

	var eq_1 = eq;

	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */

	function assocIndexOf(array, key) {
	  var length = array.length;

	  while (length--) {
	    if (eq_1(array[length][0], key)) {
	      return length;
	    }
	  }

	  return -1;
	}

	var _assocIndexOf = assocIndexOf;

	/** Used for built-in method references. */

	var arrayProto = Array.prototype;
	/** Built-in value references. */

	var splice = arrayProto.splice;
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */

	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = _assocIndexOf(data, key);

	  if (index < 0) {
	    return false;
	  }

	  var lastIndex = data.length - 1;

	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }

	  --this.size;
	  return true;
	}

	var _listCacheDelete = listCacheDelete;

	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */

	function listCacheGet(key) {
	  var data = this.__data__,
	      index = _assocIndexOf(data, key);
	  return index < 0 ? undefined : data[index][1];
	}

	var _listCacheGet = listCacheGet;

	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */

	function listCacheHas(key) {
	  return _assocIndexOf(this.__data__, key) > -1;
	}

	var _listCacheHas = listCacheHas;

	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */

	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = _assocIndexOf(data, key);

	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }

	  return this;
	}

	var _listCacheSet = listCacheSet;

	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */

	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	  this.clear();

	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	} // Add methods to `ListCache`.


	ListCache.prototype.clear = _listCacheClear;
	ListCache.prototype['delete'] = _listCacheDelete;
	ListCache.prototype.get = _listCacheGet;
	ListCache.prototype.has = _listCacheHas;
	ListCache.prototype.set = _listCacheSet;
	var _ListCache = ListCache;

	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */

	function stackClear() {
	  this.__data__ = new _ListCache();
	  this.size = 0;
	}

	var _stackClear = stackClear;

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	  this.size = data.size;
	  return result;
	}

	var _stackDelete = stackDelete;

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}

	var _stackGet = stackGet;

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}

	var _stackHas = stackHas;

	/** Detect free variable `global` from Node.js. */

	var freeGlobal = _typeof_1(commonjsGlobal) == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;
	var _freeGlobal = freeGlobal;

	/** Detect free variable `self`. */

	var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof_1(self)) == 'object' && self && self.Object === Object && self;
	/** Used as a reference to the global object. */

	var root = _freeGlobal || freeSelf || Function('return this')();
	var _root = root;

	/** Built-in value references. */

	var _Symbol2 = _root.Symbol;
	var _Symbol = _Symbol2;

	/** Used for built-in method references. */

	var objectProto = Object.prototype;
	/** Used to check objects for own properties. */

	var hasOwnProperty$1 = objectProto.hasOwnProperty;
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */

	var nativeObjectToString = objectProto.toString;
	/** Built-in value references. */

	var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */

	function getRawTag(value) {
	  var isOwn = hasOwnProperty$1.call(value, symToStringTag),
	      tag = value[symToStringTag];

	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}

	  var result = nativeObjectToString.call(value);

	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }

	  return result;
	}

	var _getRawTag = getRawTag;

	/** Used for built-in method references. */
	var objectProto$1 = Object.prototype;
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */

	var nativeObjectToString$1 = objectProto$1.toString;
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */

	function objectToString(value) {
	  return nativeObjectToString$1.call(value);
	}

	var _objectToString = objectToString;

	/** `Object#toString` result references. */

	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	/** Built-in value references. */

	var symToStringTag$1 = _Symbol ? _Symbol.toStringTag : undefined;
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */

	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }

	  return symToStringTag$1 && symToStringTag$1 in Object(value) ? _getRawTag(value) : _objectToString(value);
	}

	var _baseGetTag = baseGetTag;

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = _typeof_1(value);

	  return value != null && (type == 'object' || type == 'function');
	}

	var isObject_1 = isObject;

	/** `Object#toString` result references. */

	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */

	function isFunction(value) {
	  if (!isObject_1(value)) {
	    return false;
	  } // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.


	  var tag = _baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}

	var isFunction_1 = isFunction;

	/** Used to detect overreaching core-js shims. */

	var coreJsData = _root['__core-js_shared__'];
	var _coreJsData = coreJsData;

	/** Used to detect methods masquerading as native. */

	var maskSrcKey = function () {
	  var uid = /[^.]+$/.exec(_coreJsData && _coreJsData.keys && _coreJsData.keys.IE_PROTO || '');
	  return uid ? 'Symbol(src)_1.' + uid : '';
	}();
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */


	function isMasked(func) {
	  return !!maskSrcKey && maskSrcKey in func;
	}

	var _isMasked = isMasked;

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	/** Used to resolve the decompiled source of functions. */

	var funcToString = funcProto.toString;
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */

	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}

	    try {
	      return func + '';
	    } catch (e) {}
	  }

	  return '';
	}

	var _toSource = toSource;

	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */

	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	/** Used to detect host constructors (Safari). */

	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	/** Used for built-in method references. */

	var funcProto$1 = Function.prototype,
	    objectProto$2 = Object.prototype;
	/** Used to resolve the decompiled source of functions. */

	var funcToString$1 = funcProto$1.toString;
	/** Used to check objects for own properties. */

	var hasOwnProperty$2 = objectProto$2.hasOwnProperty;
	/** Used to detect if a method is native. */

	var reIsNative = RegExp('^' + funcToString$1.call(hasOwnProperty$2).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */

	function baseIsNative(value) {
	  if (!isObject_1(value) || _isMasked(value)) {
	    return false;
	  }

	  var pattern = isFunction_1(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(_toSource(value));
	}

	var _baseIsNative = baseIsNative;

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}

	var _getValue = getValue;

	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */

	function getNative(object, key) {
	  var value = _getValue(object, key);
	  return _baseIsNative(value) ? value : undefined;
	}

	var _getNative = getNative;

	/* Built-in method references that are verified to be native. */

	var Map = _getNative(_root, 'Map');
	var _Map = Map;

	/* Built-in method references that are verified to be native. */

	var nativeCreate = _getNative(Object, 'create');
	var _nativeCreate = nativeCreate;

	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */

	function hashClear() {
	  this.__data__ = _nativeCreate ? _nativeCreate(null) : {};
	  this.size = 0;
	}

	var _hashClear = hashClear;

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}

	var _hashDelete = hashDelete;

	/** Used to stand-in for `undefined` hash values. */

	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	/** Used for built-in method references. */

	var objectProto$3 = Object.prototype;
	/** Used to check objects for own properties. */

	var hasOwnProperty$3 = objectProto$3.hasOwnProperty;
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */

	function hashGet(key) {
	  var data = this.__data__;

	  if (_nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }

	  return hasOwnProperty$3.call(data, key) ? data[key] : undefined;
	}

	var _hashGet = hashGet;

	/** Used for built-in method references. */

	var objectProto$4 = Object.prototype;
	/** Used to check objects for own properties. */

	var hasOwnProperty$4 = objectProto$4.hasOwnProperty;
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */

	function hashHas(key) {
	  var data = this.__data__;
	  return _nativeCreate ? data[key] !== undefined : hasOwnProperty$4.call(data, key);
	}

	var _hashHas = hashHas;

	/** Used to stand-in for `undefined` hash values. */

	var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */

	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = _nativeCreate && value === undefined ? HASH_UNDEFINED$1 : value;
	  return this;
	}

	var _hashSet = hashSet;

	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */

	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	  this.clear();

	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	} // Add methods to `Hash`.


	Hash.prototype.clear = _hashClear;
	Hash.prototype['delete'] = _hashDelete;
	Hash.prototype.get = _hashGet;
	Hash.prototype.has = _hashHas;
	Hash.prototype.set = _hashSet;
	var _Hash = Hash;

	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */

	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new _Hash(),
	    'map': new (_Map || _ListCache)(),
	    'string': new _Hash()
	  };
	}

	var _mapCacheClear = mapCacheClear;

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = _typeof_1(value);

	  return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
	}

	var _isKeyable = isKeyable;

	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */

	function getMapData(map, key) {
	  var data = map.__data__;
	  return _isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
	}

	var _getMapData = getMapData;

	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */

	function mapCacheDelete(key) {
	  var result = _getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}

	var _mapCacheDelete = mapCacheDelete;

	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */

	function mapCacheGet(key) {
	  return _getMapData(this, key).get(key);
	}

	var _mapCacheGet = mapCacheGet;

	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */

	function mapCacheHas(key) {
	  return _getMapData(this, key).has(key);
	}

	var _mapCacheHas = mapCacheHas;

	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */

	function mapCacheSet(key, value) {
	  var data = _getMapData(this, key),
	      size = data.size;
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}

	var _mapCacheSet = mapCacheSet;

	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */

	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	  this.clear();

	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	} // Add methods to `MapCache`.


	MapCache.prototype.clear = _mapCacheClear;
	MapCache.prototype['delete'] = _mapCacheDelete;
	MapCache.prototype.get = _mapCacheGet;
	MapCache.prototype.has = _mapCacheHas;
	MapCache.prototype.set = _mapCacheSet;
	var _MapCache = MapCache;

	/** Used as the size to enable large array optimizations. */

	var LARGE_ARRAY_SIZE = 200;
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */

	function stackSet(key, value) {
	  var data = this.__data__;

	  if (data instanceof _ListCache) {
	    var pairs = data.__data__;

	    if (!_Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }

	    data = this.__data__ = new _MapCache(pairs);
	  }

	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}

	var _stackSet = stackSet;

	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */

	function Stack(entries) {
	  var data = this.__data__ = new _ListCache(entries);
	  this.size = data.size;
	} // Add methods to `Stack`.


	Stack.prototype.clear = _stackClear;
	Stack.prototype['delete'] = _stackDelete;
	Stack.prototype.get = _stackGet;
	Stack.prototype.has = _stackHas;
	Stack.prototype.set = _stackSet;
	var _Stack = Stack;

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */

	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED$2);

	  return this;
	}

	var _setCacheAdd = setCacheAdd;

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}

	var _setCacheHas = setCacheHas;

	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */

	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	  this.__data__ = new _MapCache();

	  while (++index < length) {
	    this.add(values[index]);
	  }
	} // Add methods to `SetCache`.


	SetCache.prototype.add = SetCache.prototype.push = _setCacheAdd;
	SetCache.prototype.has = _setCacheHas;
	var _SetCache = SetCache;

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;

	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }

	  return false;
	}

	var _arraySome = arraySome;

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}

	var _cacheHas = cacheHas;

	/** Used to compose bitmasks for value comparisons. */

	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */

	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;

	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  } // Assume cyclic values are equal.


	  var stacked = stack.get(array);

	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }

	  var index = -1,
	      result = true,
	      seen = bitmask & COMPARE_UNORDERED_FLAG ? new _SetCache() : undefined;
	  stack.set(array, other);
	  stack.set(other, array); // Ignore non-index properties.

	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];

	    if (customizer) {
	      var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
	    }

	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }

	      result = false;
	      break;
	    } // Recursively compare arrays (susceptible to call stack limits).


	    if (seen) {
	      if (!_arraySome(other, function (othValue, othIndex) {
	        if (!_cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	          return seen.push(othIndex);
	        }
	      })) {
	        result = false;
	        break;
	      }
	    } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	      result = false;
	      break;
	    }
	  }

	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}

	var _equalArrays = equalArrays;

	/** Built-in value references. */

	var Uint8Array = _root.Uint8Array;
	var _Uint8Array = Uint8Array;

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	  map.forEach(function (value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}

	var _mapToArray = mapToArray;

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	  set.forEach(function (value) {
	    result[++index] = value;
	  });
	  return result;
	}

	var _setToArray = setToArray;

	/** Used to compose bitmasks for value comparisons. */

	var COMPARE_PARTIAL_FLAG$1 = 1,
	    COMPARE_UNORDERED_FLAG$1 = 2;
	/** `Object#toString` result references. */

	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	/** Used to convert symbols to primitives and strings. */

	var symbolProto = _Symbol ? _Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */

	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
	        return false;
	      }

	      object = object.buffer;
	      other = other.buffer;

	    case arrayBufferTag:
	      if (object.byteLength != other.byteLength || !equalFunc(new _Uint8Array(object), new _Uint8Array(other))) {
	        return false;
	      }

	      return true;

	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq_1(+object, +other);

	    case errorTag:
	      return object.name == other.name && object.message == other.message;

	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == other + '';

	    case mapTag:
	      var convert = _mapToArray;

	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$1;
	      convert || (convert = _setToArray);

	      if (object.size != other.size && !isPartial) {
	        return false;
	      } // Assume cyclic values are equal.


	      var stacked = stack.get(object);

	      if (stacked) {
	        return stacked == other;
	      }

	      bitmask |= COMPARE_UNORDERED_FLAG$1; // Recursively compare objects (susceptible to call stack limits).

	      stack.set(object, other);
	      var result = _equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;

	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }

	  }

	  return false;
	}

	var _equalByTag = equalByTag;

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;

	  while (++index < length) {
	    array[offset + index] = values[index];
	  }

	  return array;
	}

	var _arrayPush = arrayPush;

	// 22.1.2.2 / 15.4.3.2 Array.isArray(arg)


	_export(_export.S, 'Array', { isArray: _isArray });

	var isArray = _core.Array.isArray;

	var isArray$1 = isArray;

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray$2 = isArray$1;
	var isArray_1 = isArray$2;

	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */

	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray_1(object) ? result : _arrayPush(result, symbolsFunc(object));
	}

	var _baseGetAllKeys = baseGetAllKeys;

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];

	  while (++index < length) {
	    var value = array[index];

	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }

	  return result;
	}

	var _arrayFilter = arrayFilter;

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}

	var stubArray_1 = stubArray;

	/** Used for built-in method references. */

	var objectProto$5 = Object.prototype;
	/** Built-in value references. */

	var propertyIsEnumerable = objectProto$5.propertyIsEnumerable;
	/* Built-in method references for those with the same name as other `lodash` methods. */

	var nativeGetSymbols = getOwnPropertySymbols$1;
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */

	var getSymbols = !nativeGetSymbols ? stubArray_1 : function (object) {
	  if (object == null) {
	    return [];
	  }

	  object = Object(object);
	  return _arrayFilter(nativeGetSymbols(object), function (symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	var _getSymbols = getSymbols;

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);

	  while (++index < n) {
	    result[index] = iteratee(index);
	  }

	  return result;
	}

	var _baseTimes = baseTimes;

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && _typeof_1(value) == 'object';
	}

	var isObjectLike_1 = isObjectLike;

	/** `Object#toString` result references. */

	var argsTag = '[object Arguments]';
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */

	function baseIsArguments(value) {
	  return isObjectLike_1(value) && _baseGetTag(value) == argsTag;
	}

	var _baseIsArguments = baseIsArguments;

	/** Used for built-in method references. */

	var objectProto$6 = Object.prototype;
	/** Used to check objects for own properties. */

	var hasOwnProperty$5 = objectProto$6.hasOwnProperty;
	/** Built-in value references. */

	var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */

	var isArguments = _baseIsArguments(function () {
	  return arguments;
	}()) ? _baseIsArguments : function (value) {
	  return isObjectLike_1(value) && hasOwnProperty$5.call(value, 'callee') && !propertyIsEnumerable$1.call(value, 'callee');
	};
	var isArguments_1 = isArguments;

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}

	var stubFalse_1 = stubFalse;

	var isBuffer_1 = createCommonjsModule(function (module, exports) {
	  /** Detect free variable `exports`. */
	  var freeExports =  exports && !exports.nodeType && exports;
	  /** Detect free variable `module`. */

	  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
	  /** Detect the popular CommonJS extension `module.exports`. */

	  var moduleExports = freeModule && freeModule.exports === freeExports;
	  /** Built-in value references. */

	  var Buffer = moduleExports ? _root.Buffer : undefined;
	  /* Built-in method references for those with the same name as other `lodash` methods. */

	  var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	  /**
	   * Checks if `value` is a buffer.
	   *
	   * @static
	   * @memberOf _
	   * @since 4.3.0
	   * @category Lang
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	   * @example
	   *
	   * _.isBuffer(new Buffer(2));
	   * // => true
	   *
	   * _.isBuffer(new Uint8Array(2));
	   * // => false
	   */

	  var isBuffer = nativeIsBuffer || stubFalse_1;
	  module.exports = isBuffer;
	});

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	/** Used to detect unsigned integer values. */

	var reIsUint = /^(?:0|[1-9]\d*)$/;
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */

	function isIndex(value, length) {
	  var type = _typeof_1(value);

	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
	}

	var _isIndex = isIndex;

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER$1 = 9007199254740991;
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */

	function isLength(value) {
	  return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$1;
	}

	var isLength_1 = isLength;

	/** `Object#toString` result references. */

	var argsTag$1 = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag$1 = '[object Boolean]',
	    dateTag$1 = '[object Date]',
	    errorTag$1 = '[object Error]',
	    funcTag$1 = '[object Function]',
	    mapTag$1 = '[object Map]',
	    numberTag$1 = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag$1 = '[object RegExp]',
	    setTag$1 = '[object Set]',
	    stringTag$1 = '[object String]',
	    weakMapTag = '[object WeakMap]';
	var arrayBufferTag$1 = '[object ArrayBuffer]',
	    dataViewTag$1 = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	/** Used to identify `toStringTag` values of typed arrays. */

	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag$1] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag$1] = typedArrayTags[boolTag$1] = typedArrayTags[dataViewTag$1] = typedArrayTags[dateTag$1] = typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] = typedArrayTags[mapTag$1] = typedArrayTags[numberTag$1] = typedArrayTags[objectTag] = typedArrayTags[regexpTag$1] = typedArrayTags[setTag$1] = typedArrayTags[stringTag$1] = typedArrayTags[weakMapTag] = false;
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */

	function baseIsTypedArray(value) {
	  return isObjectLike_1(value) && isLength_1(value.length) && !!typedArrayTags[_baseGetTag(value)];
	}

	var _baseIsTypedArray = baseIsTypedArray;

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function (value) {
	    return func(value);
	  };
	}

	var _baseUnary = baseUnary;

	var _nodeUtil = createCommonjsModule(function (module, exports) {
	  /** Detect free variable `exports`. */
	  var freeExports =  exports && !exports.nodeType && exports;
	  /** Detect free variable `module`. */

	  var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;
	  /** Detect the popular CommonJS extension `module.exports`. */

	  var moduleExports = freeModule && freeModule.exports === freeExports;
	  /** Detect free variable `process` from Node.js. */

	  var freeProcess = moduleExports && _freeGlobal.process;
	  /** Used to access faster Node.js helpers. */

	  var nodeUtil = function () {
	    try {
	      // Use `util.types` for Node.js 10+.
	      var types = freeModule && freeModule.require && freeModule.require('util').types;

	      if (types) {
	        return types;
	      } // Legacy `process.binding('util')` for Node.js < 10.


	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }();

	  module.exports = nodeUtil;
	});

	/* Node.js helper references. */

	var nodeIsTypedArray = _nodeUtil && _nodeUtil.isTypedArray;
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */

	var isTypedArray = nodeIsTypedArray ? _baseUnary(nodeIsTypedArray) : _baseIsTypedArray;
	var isTypedArray_1 = isTypedArray;

	/** Used for built-in method references. */

	var objectProto$7 = Object.prototype;
	/** Used to check objects for own properties. */

	var hasOwnProperty$6 = objectProto$7.hasOwnProperty;
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */

	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray_1(value),
	      isArg = !isArr && isArguments_1(value),
	      isBuff = !isArr && !isArg && isBuffer_1(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray_1(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? _baseTimes(value.length, String) : [],
	      length = result.length;

	  for (var key in value) {
	    if ((inherited || hasOwnProperty$6.call(value, key)) && !(skipIndexes && ( // Safari 9 has enumerable `arguments.length` in strict mode.
	    key == 'length' || // Node.js 0.10 has enumerable non-index properties on buffers.
	    isBuff && (key == 'offset' || key == 'parent') || // PhantomJS 2 has enumerable non-index properties on typed arrays.
	    isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') || // Skip index properties.
	    _isIndex(key, length)))) {
	      result.push(key);
	    }
	  }

	  return result;
	}

	var _arrayLikeKeys = arrayLikeKeys;

	/** Used for built-in method references. */
	var objectProto$8 = Object.prototype;
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */

	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = typeof Ctor == 'function' && Ctor.prototype || objectProto$8;
	  return value === proto;
	}

	var _isPrototype = isPrototype;

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function (arg) {
	    return func(transform(arg));
	  };
	}

	var _overArg = overArg;

	/* Built-in method references for those with the same name as other `lodash` methods. */

	var nativeKeys = _overArg(keys$1, Object);
	var _nativeKeys = nativeKeys;

	/** Used for built-in method references. */

	var objectProto$9 = Object.prototype;
	/** Used to check objects for own properties. */

	var hasOwnProperty$7 = objectProto$9.hasOwnProperty;
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */

	function baseKeys(object) {
	  if (!_isPrototype(object)) {
	    return _nativeKeys(object);
	  }

	  var result = [];

	  for (var key in Object(object)) {
	    if (hasOwnProperty$7.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }

	  return result;
	}

	var _baseKeys = baseKeys;

	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */

	function isArrayLike(value) {
	  return value != null && isLength_1(value.length) && !isFunction_1(value);
	}

	var isArrayLike_1 = isArrayLike;

	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */

	function keys$2(object) {
	  return isArrayLike_1(object) ? _arrayLikeKeys(object) : _baseKeys(object);
	}

	var keys_1 = keys$2;

	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */

	function getAllKeys(object) {
	  return _baseGetAllKeys(object, keys_1, _getSymbols);
	}

	var _getAllKeys = getAllKeys;

	/** Used to compose bitmasks for value comparisons. */

	var COMPARE_PARTIAL_FLAG$2 = 1;
	/** Used for built-in method references. */

	var objectProto$a = Object.prototype;
	/** Used to check objects for own properties. */

	var hasOwnProperty$8 = objectProto$a.hasOwnProperty;
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */

	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$2,
	      objProps = _getAllKeys(object),
	      objLength = objProps.length,
	      othProps = _getAllKeys(other),
	      othLength = othProps.length;

	  if (objLength != othLength && !isPartial) {
	    return false;
	  }

	  var index = objLength;

	  while (index--) {
	    var key = objProps[index];

	    if (!(isPartial ? key in other : hasOwnProperty$8.call(other, key))) {
	      return false;
	    }
	  } // Assume cyclic values are equal.


	  var stacked = stack.get(object);

	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }

	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	  var skipCtor = isPartial;

	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];

	    if (customizer) {
	      var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
	    } // Recursively compare objects (susceptible to call stack limits).


	    if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
	      result = false;
	      break;
	    }

	    skipCtor || (skipCtor = key == 'constructor');
	  }

	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor; // Non `Object` object instances with different constructors are not equal.

	    if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }

	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}

	var _equalObjects = equalObjects;

	/* Built-in method references that are verified to be native. */

	var DataView = _getNative(_root, 'DataView');
	var _DataView = DataView;

	/* Built-in method references that are verified to be native. */

	var Promise = _getNative(_root, 'Promise');
	var _Promise = Promise;

	/* Built-in method references that are verified to be native. */

	var Set = _getNative(_root, 'Set');
	var _Set = Set;

	/* Built-in method references that are verified to be native. */

	var WeakMap = _getNative(_root, 'WeakMap');
	var _WeakMap = WeakMap;

	/** `Object#toString` result references. */

	var mapTag$2 = '[object Map]',
	    objectTag$1 = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag$2 = '[object Set]',
	    weakMapTag$1 = '[object WeakMap]';
	var dataViewTag$2 = '[object DataView]';
	/** Used to detect maps, sets, and weakmaps. */

	var dataViewCtorString = _toSource(_DataView),
	    mapCtorString = _toSource(_Map),
	    promiseCtorString = _toSource(_Promise),
	    setCtorString = _toSource(_Set),
	    weakMapCtorString = _toSource(_WeakMap);
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */

	var getTag = _baseGetTag; // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.

	if (_DataView && getTag(new _DataView(new ArrayBuffer(1))) != dataViewTag$2 || _Map && getTag(new _Map()) != mapTag$2 || _Promise && getTag(_Promise.resolve()) != promiseTag || _Set && getTag(new _Set()) != setTag$2 || _WeakMap && getTag(new _WeakMap()) != weakMapTag$1) {
	  getTag = function getTag(value) {
	    var result = _baseGetTag(value),
	        Ctor = result == objectTag$1 ? value.constructor : undefined,
	        ctorString = Ctor ? _toSource(Ctor) : '';

	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString:
	          return dataViewTag$2;

	        case mapCtorString:
	          return mapTag$2;

	        case promiseCtorString:
	          return promiseTag;

	        case setCtorString:
	          return setTag$2;

	        case weakMapCtorString:
	          return weakMapTag$1;
	      }
	    }

	    return result;
	  };
	}

	var _getTag = getTag;

	/** Used to compose bitmasks for value comparisons. */

	var COMPARE_PARTIAL_FLAG$3 = 1;
	/** `Object#toString` result references. */

	var argsTag$2 = '[object Arguments]',
	    arrayTag$1 = '[object Array]',
	    objectTag$2 = '[object Object]';
	/** Used for built-in method references. */

	var objectProto$b = Object.prototype;
	/** Used to check objects for own properties. */

	var hasOwnProperty$9 = objectProto$b.hasOwnProperty;
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */

	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray_1(object),
	      othIsArr = isArray_1(other),
	      objTag = objIsArr ? arrayTag$1 : _getTag(object),
	      othTag = othIsArr ? arrayTag$1 : _getTag(other);
	  objTag = objTag == argsTag$2 ? objectTag$2 : objTag;
	  othTag = othTag == argsTag$2 ? objectTag$2 : othTag;
	  var objIsObj = objTag == objectTag$2,
	      othIsObj = othTag == objectTag$2,
	      isSameTag = objTag == othTag;

	  if (isSameTag && isBuffer_1(object)) {
	    if (!isBuffer_1(other)) {
	      return false;
	    }

	    objIsArr = true;
	    objIsObj = false;
	  }

	  if (isSameTag && !objIsObj) {
	    stack || (stack = new _Stack());
	    return objIsArr || isTypedArray_1(object) ? _equalArrays(object, other, bitmask, customizer, equalFunc, stack) : _equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }

	  if (!(bitmask & COMPARE_PARTIAL_FLAG$3)) {
	    var objIsWrapped = objIsObj && hasOwnProperty$9.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty$9.call(other, '__wrapped__');

	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	      stack || (stack = new _Stack());
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }

	  if (!isSameTag) {
	    return false;
	  }

	  stack || (stack = new _Stack());
	  return _equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}

	var _baseIsEqualDeep = baseIsEqualDeep;

	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */

	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }

	  if (value == null || other == null || !isObjectLike_1(value) && !isObjectLike_1(other)) {
	    return value !== value && other !== other;
	  }

	  return _baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}

	var _baseIsEqual = baseIsEqual;

	/** Used to compose bitmasks for value comparisons. */

	var COMPARE_PARTIAL_FLAG$4 = 1,
	    COMPARE_UNORDERED_FLAG$2 = 2;
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */

	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;

	  if (object == null) {
	    return !length;
	  }

	  object = Object(object);

	  while (index--) {
	    var data = matchData[index];

	    if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
	      return false;
	    }
	  }

	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];

	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new _Stack();

	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }

	      if (!(result === undefined ? _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$4 | COMPARE_UNORDERED_FLAG$2, customizer, stack) : result)) {
	        return false;
	      }
	    }
	  }

	  return true;
	}

	var _baseIsMatch = baseIsMatch;

	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */

	function isStrictComparable(value) {
	  return value === value && !isObject_1(value);
	}

	var _isStrictComparable = isStrictComparable;

	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */

	function getMatchData(object) {
	  var result = keys_1(object),
	      length = result.length;

	  while (length--) {
	    var key = result[length],
	        value = object[key];
	    result[length] = [key, value, _isStrictComparable(value)];
	  }

	  return result;
	}

	var _getMatchData = getMatchData;

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function (object) {
	    if (object == null) {
	      return false;
	    }

	    return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
	  };
	}

	var _matchesStrictComparable = matchesStrictComparable;

	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */

	function baseMatches(source) {
	  var matchData = _getMatchData(source);

	  if (matchData.length == 1 && matchData[0][2]) {
	    return _matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }

	  return function (object) {
	    return object === source || _baseIsMatch(object, source, matchData);
	  };
	}

	var _baseMatches = baseMatches;

	/** `Object#toString` result references. */

	var symbolTag$1 = '[object Symbol]';
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */

	function isSymbol$1(value) {
	  return _typeof_1(value) == 'symbol' || isObjectLike_1(value) && _baseGetTag(value) == symbolTag$1;
	}

	var isSymbol_1 = isSymbol$1;

	/** Used to match property names within property paths. */

	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */

	function isKey(value, object) {
	  if (isArray_1(value)) {
	    return false;
	  }

	  var type = _typeof_1(value);

	  if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol_1(value)) {
	    return true;
	  }

	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
	}

	var _isKey = isKey;

	/** Error message constants. */

	var FUNC_ERROR_TEXT = 'Expected a function';
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */

	function memoize(func, resolver) {
	  if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }

	  var memoized = function memoized() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;

	    if (cache.has(key)) {
	      return cache.get(key);
	    }

	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };

	  memoized.cache = new (memoize.Cache || _MapCache)();
	  return memoized;
	} // Expose `MapCache`.


	memoize.Cache = _MapCache;
	var memoize_1 = memoize;

	/** Used as the maximum memoize cache size. */

	var MAX_MEMOIZE_SIZE = 500;
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */

	function memoizeCapped(func) {
	  var result = memoize_1(func, function (key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }

	    return key;
	  });
	  var cache = result.cache;
	  return result;
	}

	var _memoizeCapped = memoizeCapped;

	/** Used to match property names within property paths. */

	var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	/** Used to match backslashes in property paths. */

	var reEscapeChar = /\\(\\)?/g;
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */

	var stringToPath = _memoizeCapped(function (string) {
	  var result = [];

	  if (string.charCodeAt(0) === 46
	  /* . */
	  ) {
	      result.push('');
	    }

	  string.replace(rePropName, function (match, number, quote, subString) {
	    result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
	  });
	  return result;
	});
	var _stringToPath = stringToPath;

	/** Used as references for various `Number` constants. */

	var INFINITY = 1 / 0;
	/** Used to convert symbols to primitives and strings. */

	var symbolProto$1 = _Symbol ? _Symbol.prototype : undefined,
	    symbolToString = symbolProto$1 ? symbolProto$1.toString : undefined;
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */

	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }

	  if (isArray_1(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return _arrayMap(value, baseToString) + '';
	  }

	  if (isSymbol_1(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }

	  var result = value + '';
	  return result == '0' && 1 / value == -INFINITY ? '-0' : result;
	}

	var _baseToString = baseToString;

	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */

	function toString$2(value) {
	  return value == null ? '' : _baseToString(value);
	}

	var toString_1 = toString$2;

	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */

	function castPath(value, object) {
	  if (isArray_1(value)) {
	    return value;
	  }

	  return _isKey(value, object) ? [value] : _stringToPath(toString_1(value));
	}

	var _castPath = castPath;

	/** Used as references for various `Number` constants. */

	var INFINITY$1 = 1 / 0;
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */

	function toKey(value) {
	  if (typeof value == 'string' || isSymbol_1(value)) {
	    return value;
	  }

	  var result = value + '';
	  return result == '0' && 1 / value == -INFINITY$1 ? '-0' : result;
	}

	var _toKey = toKey;

	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */

	function baseGet(object, path) {
	  path = _castPath(path, object);
	  var index = 0,
	      length = path.length;

	  while (object != null && index < length) {
	    object = object[_toKey(path[index++])];
	  }

	  return index && index == length ? object : undefined;
	}

	var _baseGet = baseGet;

	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */

	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : _baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}

	var get_1 = get;

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}

	var _baseHasIn = baseHasIn;

	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */

	function hasPath(object, path, hasFunc) {
	  path = _castPath(path, object);
	  var index = -1,
	      length = path.length,
	      result = false;

	  while (++index < length) {
	    var key = _toKey(path[index]);

	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }

	    object = object[key];
	  }

	  if (result || ++index != length) {
	    return result;
	  }

	  length = object == null ? 0 : object.length;
	  return !!length && isLength_1(length) && _isIndex(key, length) && (isArray_1(object) || isArguments_1(object));
	}

	var _hasPath = hasPath;

	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */

	function hasIn(object, path) {
	  return object != null && _hasPath(object, path, _baseHasIn);
	}

	var hasIn_1 = hasIn;

	/** Used to compose bitmasks for value comparisons. */

	var COMPARE_PARTIAL_FLAG$5 = 1,
	    COMPARE_UNORDERED_FLAG$3 = 2;
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */

	function baseMatchesProperty(path, srcValue) {
	  if (_isKey(path) && _isStrictComparable(srcValue)) {
	    return _matchesStrictComparable(_toKey(path), srcValue);
	  }

	  return function (object) {
	    var objValue = get_1(object, path);
	    return objValue === undefined && objValue === srcValue ? hasIn_1(object, path) : _baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG$5 | COMPARE_UNORDERED_FLAG$3);
	  };
	}

	var _baseMatchesProperty = baseMatchesProperty;

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}

	var identity_1 = identity;

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function (object) {
	    return object == null ? undefined : object[key];
	  };
	}

	var _baseProperty = baseProperty;

	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */

	function basePropertyDeep(path) {
	  return function (object) {
	    return _baseGet(object, path);
	  };
	}

	var _basePropertyDeep = basePropertyDeep;

	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */

	function property(path) {
	  return _isKey(path) ? _baseProperty(_toKey(path)) : _basePropertyDeep(path);
	}

	var property_1 = property;

	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */

	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }

	  if (value == null) {
	    return identity_1;
	  }

	  if (_typeof_1(value) == 'object') {
	    return isArray_1(value) ? _baseMatchesProperty(value[0], value[1]) : _baseMatches(value);
	  }

	  return property_1(value);
	}

	var _baseIteratee = baseIteratee;

	var defineProperty$4 = function () {
	  try {
	    var func = _getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}();

	var _defineProperty$1 = defineProperty$4;

	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */

	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && _defineProperty$1) {
	    _defineProperty$1(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}

	var _baseAssignValue = baseAssignValue;

	/** Used for built-in method references. */

	var objectProto$c = Object.prototype;
	/** Used to check objects for own properties. */

	var hasOwnProperty$a = objectProto$c.hasOwnProperty;
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */

	function assignValue(object, key, value) {
	  var objValue = object[key];

	  if (!(hasOwnProperty$a.call(object, key) && eq_1(objValue, value)) || value === undefined && !(key in object)) {
	    _baseAssignValue(object, key, value);
	  }
	}

	var _assignValue = assignValue;

	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */

	function baseSet(object, path, value, customizer) {
	  if (!isObject_1(object)) {
	    return object;
	  }

	  path = _castPath(path, object);
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;

	  while (nested != null && ++index < length) {
	    var key = _toKey(path[index]),
	        newValue = value;

	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;

	      if (newValue === undefined) {
	        newValue = isObject_1(objValue) ? objValue : _isIndex(path[index + 1]) ? [] : {};
	      }
	    }

	    _assignValue(nested, key, newValue);
	    nested = nested[key];
	  }

	  return object;
	}

	var _baseSet = baseSet;

	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */

	function basePickBy(object, paths, predicate) {
	  var index = -1,
	      length = paths.length,
	      result = {};

	  while (++index < length) {
	    var path = paths[index],
	        value = _baseGet(object, path);

	    if (predicate(value, path)) {
	      _baseSet(result, _castPath(path, object), value);
	    }
	  }

	  return result;
	}

	var _basePickBy = basePickBy;

	// 19.1.2.9 Object.getPrototypeOf(O)



	_objectSap('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return _objectGpo(_toObject(it));
	  };
	});

	var getPrototypeOf = _core.Object.getPrototypeOf;

	var getPrototypeOf$1 = getPrototypeOf;

	/** Built-in value references. */

	var getPrototype = _overArg(getPrototypeOf$1, Object);
	var _getPrototype = getPrototype;

	/* Built-in method references for those with the same name as other `lodash` methods. */

	var nativeGetSymbols$1 = getOwnPropertySymbols$1;
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */

	var getSymbolsIn = !nativeGetSymbols$1 ? stubArray_1 : function (object) {
	  var result = [];

	  while (object) {
	    _arrayPush(result, _getSymbols(object));
	    object = _getPrototype(object);
	  }

	  return result;
	};
	var _getSymbolsIn = getSymbolsIn;

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];

	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }

	  return result;
	}

	var _nativeKeysIn = nativeKeysIn;

	/** Used for built-in method references. */

	var objectProto$d = Object.prototype;
	/** Used to check objects for own properties. */

	var hasOwnProperty$b = objectProto$d.hasOwnProperty;
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */

	function baseKeysIn(object) {
	  if (!isObject_1(object)) {
	    return _nativeKeysIn(object);
	  }

	  var isProto = _isPrototype(object),
	      result = [];

	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty$b.call(object, key)))) {
	      result.push(key);
	    }
	  }

	  return result;
	}

	var _baseKeysIn = baseKeysIn;

	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */

	function keysIn(object) {
	  return isArrayLike_1(object) ? _arrayLikeKeys(object, true) : _baseKeysIn(object);
	}

	var keysIn_1 = keysIn;

	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */

	function getAllKeysIn(object) {
	  return _baseGetAllKeys(object, keysIn_1, _getSymbolsIn);
	}

	var _getAllKeysIn = getAllKeysIn;

	/**
	 * Creates an object composed of the `object` properties `predicate` returns
	 * truthy for. The predicate is invoked with two arguments: (value, key).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function} [predicate=_.identity] The function invoked per property.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pickBy(object, _.isNumber);
	 * // => { 'a': 1, 'c': 3 }
	 */

	function pickBy(object, predicate) {
	  if (object == null) {
	    return {};
	  }

	  var props = _arrayMap(_getAllKeysIn(object), function (prop) {
	    return [prop];
	  });
	  predicate = _baseIteratee(predicate);
	  return _basePickBy(object, props, function (value, path) {
	    return predicate(value, path[0]);
	  });
	}

	var pickBy_1 = pickBy;

	// getting tag from 19.1.3.6 Object.prototype.toString()

	var TAG$1 = _wks('toStringTag');
	// ES3 wrong here
	var ARG = _cof(function () { return arguments; }()) == 'Arguments';

	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};

	var _classof = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG$1)) == 'string' ? T
	    // builtinTag case
	    : ARG ? _cof(O)
	    // ES3 arguments fallback
	    : (B = _cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};

	var _anInstance = function (it, Constructor, name, forbiddenField) {
	  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
	    throw TypeError(name + ': incorrect invocation!');
	  } return it;
	};

	// call something on iterator step with safe closing on error

	var _iterCall = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(_anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) _anObject(ret.call(iterator));
	    throw e;
	  }
	};

	// check on default Array iterator

	var ITERATOR$1 = _wks('iterator');
	var ArrayProto = Array.prototype;

	var _isArrayIter = function (it) {
	  return it !== undefined && (_iterators.Array === it || ArrayProto[ITERATOR$1] === it);
	};

	var ITERATOR$2 = _wks('iterator');

	var core_getIteratorMethod = _core.getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR$2]
	    || it['@@iterator']
	    || _iterators[_classof(it)];
	};

	var _forOf = createCommonjsModule(function (module) {
	var BREAK = {};
	var RETURN = {};
	var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	  var iterFn = ITERATOR ? function () { return iterable; } : core_getIteratorMethod(iterable);
	  var f = _ctx(fn, that, entries ? 2 : 1);
	  var index = 0;
	  var length, step, iterator, result;
	  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	  // fast case for arrays with default iterator
	  if (_isArrayIter(iterFn)) for (length = _toLength(iterable.length); length > index; index++) {
	    result = entries ? f(_anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	    if (result === BREAK || result === RETURN) return result;
	  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	    result = _iterCall(iterator, f, step.value, entries);
	    if (result === BREAK || result === RETURN) return result;
	  }
	};
	exports.BREAK = BREAK;
	exports.RETURN = RETURN;
	});

	// 7.3.20 SpeciesConstructor(O, defaultConstructor)


	var SPECIES = _wks('species');
	var _speciesConstructor = function (O, D) {
	  var C = _anObject(O).constructor;
	  var S;
	  return C === undefined || (S = _anObject(C)[SPECIES]) == undefined ? D : _aFunction(S);
	};

	// fast apply, http://jsperf.lnkit.com/fast-apply/5
	var _invoke = function (fn, args, that) {
	  var un = that === undefined;
	  switch (args.length) {
	    case 0: return un ? fn()
	                      : fn.call(that);
	    case 1: return un ? fn(args[0])
	                      : fn.call(that, args[0]);
	    case 2: return un ? fn(args[0], args[1])
	                      : fn.call(that, args[0], args[1]);
	    case 3: return un ? fn(args[0], args[1], args[2])
	                      : fn.call(that, args[0], args[1], args[2]);
	    case 4: return un ? fn(args[0], args[1], args[2], args[3])
	                      : fn.call(that, args[0], args[1], args[2], args[3]);
	  } return fn.apply(that, args);
	};

	var process = _global.process;
	var setTask = _global.setImmediate;
	var clearTask = _global.clearImmediate;
	var MessageChannel = _global.MessageChannel;
	var Dispatch = _global.Dispatch;
	var counter = 0;
	var queue = {};
	var ONREADYSTATECHANGE = 'onreadystatechange';
	var defer, channel, port;
	var run = function () {
	  var id = +this;
	  // eslint-disable-next-line no-prototype-builtins
	  if (queue.hasOwnProperty(id)) {
	    var fn = queue[id];
	    delete queue[id];
	    fn();
	  }
	};
	var listener = function (event) {
	  run.call(event.data);
	};
	// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	if (!setTask || !clearTask) {
	  setTask = function setImmediate(fn) {
	    var args = [];
	    var i = 1;
	    while (arguments.length > i) args.push(arguments[i++]);
	    queue[++counter] = function () {
	      // eslint-disable-next-line no-new-func
	      _invoke(typeof fn == 'function' ? fn : Function(fn), args);
	    };
	    defer(counter);
	    return counter;
	  };
	  clearTask = function clearImmediate(id) {
	    delete queue[id];
	  };
	  // Node.js 0.8-
	  if (_cof(process) == 'process') {
	    defer = function (id) {
	      process.nextTick(_ctx(run, id, 1));
	    };
	  // Sphere (JS game engine) Dispatch API
	  } else if (Dispatch && Dispatch.now) {
	    defer = function (id) {
	      Dispatch.now(_ctx(run, id, 1));
	    };
	  // Browsers with MessageChannel, includes WebWorkers
	  } else if (MessageChannel) {
	    channel = new MessageChannel();
	    port = channel.port2;
	    channel.port1.onmessage = listener;
	    defer = _ctx(port.postMessage, port, 1);
	  // Browsers with postMessage, skip WebWorkers
	  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	  } else if (_global.addEventListener && typeof postMessage == 'function' && !_global.importScripts) {
	    defer = function (id) {
	      _global.postMessage(id + '', '*');
	    };
	    _global.addEventListener('message', listener, false);
	  // IE8-
	  } else if (ONREADYSTATECHANGE in _domCreate('script')) {
	    defer = function (id) {
	      _html.appendChild(_domCreate('script'))[ONREADYSTATECHANGE] = function () {
	        _html.removeChild(this);
	        run.call(id);
	      };
	    };
	  // Rest old browsers
	  } else {
	    defer = function (id) {
	      setTimeout(_ctx(run, id, 1), 0);
	    };
	  }
	}
	var _task = {
	  set: setTask,
	  clear: clearTask
	};

	var macrotask = _task.set;
	var Observer = _global.MutationObserver || _global.WebKitMutationObserver;
	var process$1 = _global.process;
	var Promise$1 = _global.Promise;
	var isNode = _cof(process$1) == 'process';

	var _microtask = function () {
	  var head, last, notify;

	  var flush = function () {
	    var parent, fn;
	    if (isNode && (parent = process$1.domain)) parent.exit();
	    while (head) {
	      fn = head.fn;
	      head = head.next;
	      try {
	        fn();
	      } catch (e) {
	        if (head) notify();
	        else last = undefined;
	        throw e;
	      }
	    } last = undefined;
	    if (parent) parent.enter();
	  };

	  // Node.js
	  if (isNode) {
	    notify = function () {
	      process$1.nextTick(flush);
	    };
	  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
	  } else if (Observer && !(_global.navigator && _global.navigator.standalone)) {
	    var toggle = true;
	    var node = document.createTextNode('');
	    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	    notify = function () {
	      node.data = toggle = !toggle;
	    };
	  // environments with maybe non-completely correct, but existent Promise
	  } else if (Promise$1 && Promise$1.resolve) {
	    // Promise.resolve without an argument throws an error in LG WebOS 2
	    var promise = Promise$1.resolve(undefined);
	    notify = function () {
	      promise.then(flush);
	    };
	  // for other environments - macrotask based on:
	  // - setImmediate
	  // - MessageChannel
	  // - window.postMessag
	  // - onreadystatechange
	  // - setTimeout
	  } else {
	    notify = function () {
	      // strange IE + webpack dev server bug - use .call(global)
	      macrotask.call(_global, flush);
	    };
	  }

	  return function (fn) {
	    var task = { fn: fn, next: undefined };
	    if (last) last.next = task;
	    if (!head) {
	      head = task;
	      notify();
	    } last = task;
	  };
	};

	// 25.4.1.5 NewPromiseCapability(C)


	function PromiseCapability(C) {
	  var resolve, reject;
	  this.promise = new C(function ($$resolve, $$reject) {
	    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	    resolve = $$resolve;
	    reject = $$reject;
	  });
	  this.resolve = _aFunction(resolve);
	  this.reject = _aFunction(reject);
	}

	var f$7 = function (C) {
	  return new PromiseCapability(C);
	};

	var _newPromiseCapability = {
		f: f$7
	};

	var _perform = function (exec) {
	  try {
	    return { e: false, v: exec() };
	  } catch (e) {
	    return { e: true, v: e };
	  }
	};

	var navigator$1 = _global.navigator;

	var _userAgent = navigator$1 && navigator$1.userAgent || '';

	var _promiseResolve = function (C, x) {
	  _anObject(C);
	  if (_isObject(x) && x.constructor === C) return x;
	  var promiseCapability = _newPromiseCapability.f(C);
	  var resolve = promiseCapability.resolve;
	  resolve(x);
	  return promiseCapability.promise;
	};

	var _redefineAll = function (target, src, safe) {
	  for (var key in src) {
	    if (safe && target[key]) target[key] = src[key];
	    else _hide(target, key, src[key]);
	  } return target;
	};

	var SPECIES$1 = _wks('species');

	var _setSpecies = function (KEY) {
	  var C = typeof _core[KEY] == 'function' ? _core[KEY] : _global[KEY];
	  if (_descriptors && C && !C[SPECIES$1]) _objectDp.f(C, SPECIES$1, {
	    configurable: true,
	    get: function () { return this; }
	  });
	};

	var ITERATOR$3 = _wks('iterator');
	var SAFE_CLOSING = false;

	try {
	  var riter = [7][ITERATOR$3]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }

	var _iterDetect = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR$3]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR$3] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};

	var task = _task.set;
	var microtask = _microtask();




	var PROMISE = 'Promise';
	var TypeError$1 = _global.TypeError;
	var process$2 = _global.process;
	var versions = process$2 && process$2.versions;
	var v8 = versions && versions.v8 || '';
	var $Promise = _global[PROMISE];
	var isNode$1 = _classof(process$2) == 'process';
	var empty = function () { /* empty */ };
	var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
	var newPromiseCapability = newGenericPromiseCapability = _newPromiseCapability.f;

	var USE_NATIVE$1 = !!function () {
	  try {
	    // correct subclassing with @@species support
	    var promise = $Promise.resolve(1);
	    var FakePromise = (promise.constructor = {})[_wks('species')] = function (exec) {
	      exec(empty, empty);
	    };
	    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	    return (isNode$1 || typeof PromiseRejectionEvent == 'function')
	      && promise.then(empty) instanceof FakePromise
	      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
	      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
	      // we can't detect it synchronously, so just check versions
	      && v8.indexOf('6.6') !== 0
	      && _userAgent.indexOf('Chrome/66') === -1;
	  } catch (e) { /* empty */ }
	}();

	// helpers
	var isThenable = function (it) {
	  var then;
	  return _isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	};
	var notify = function (promise, isReject) {
	  if (promise._n) return;
	  promise._n = true;
	  var chain = promise._c;
	  microtask(function () {
	    var value = promise._v;
	    var ok = promise._s == 1;
	    var i = 0;
	    var run = function (reaction) {
	      var handler = ok ? reaction.ok : reaction.fail;
	      var resolve = reaction.resolve;
	      var reject = reaction.reject;
	      var domain = reaction.domain;
	      var result, then, exited;
	      try {
	        if (handler) {
	          if (!ok) {
	            if (promise._h == 2) onHandleUnhandled(promise);
	            promise._h = 1;
	          }
	          if (handler === true) result = value;
	          else {
	            if (domain) domain.enter();
	            result = handler(value); // may throw
	            if (domain) {
	              domain.exit();
	              exited = true;
	            }
	          }
	          if (result === reaction.promise) {
	            reject(TypeError$1('Promise-chain cycle'));
	          } else if (then = isThenable(result)) {
	            then.call(result, resolve, reject);
	          } else resolve(result);
	        } else reject(value);
	      } catch (e) {
	        if (domain && !exited) domain.exit();
	        reject(e);
	      }
	    };
	    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
	    promise._c = [];
	    promise._n = false;
	    if (isReject && !promise._h) onUnhandled(promise);
	  });
	};
	var onUnhandled = function (promise) {
	  task.call(_global, function () {
	    var value = promise._v;
	    var unhandled = isUnhandled(promise);
	    var result, handler, console;
	    if (unhandled) {
	      result = _perform(function () {
	        if (isNode$1) {
	          process$2.emit('unhandledRejection', value, promise);
	        } else if (handler = _global.onunhandledrejection) {
	          handler({ promise: promise, reason: value });
	        } else if ((console = _global.console) && console.error) {
	          console.error('Unhandled promise rejection', value);
	        }
	      });
	      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	      promise._h = isNode$1 || isUnhandled(promise) ? 2 : 1;
	    } promise._a = undefined;
	    if (unhandled && result.e) throw result.v;
	  });
	};
	var isUnhandled = function (promise) {
	  return promise._h !== 1 && (promise._a || promise._c).length === 0;
	};
	var onHandleUnhandled = function (promise) {
	  task.call(_global, function () {
	    var handler;
	    if (isNode$1) {
	      process$2.emit('rejectionHandled', promise);
	    } else if (handler = _global.onrejectionhandled) {
	      handler({ promise: promise, reason: promise._v });
	    }
	  });
	};
	var $reject = function (value) {
	  var promise = this;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  promise._v = value;
	  promise._s = 2;
	  if (!promise._a) promise._a = promise._c.slice();
	  notify(promise, true);
	};
	var $resolve = function (value) {
	  var promise = this;
	  var then;
	  if (promise._d) return;
	  promise._d = true;
	  promise = promise._w || promise; // unwrap
	  try {
	    if (promise === value) throw TypeError$1("Promise can't be resolved itself");
	    if (then = isThenable(value)) {
	      microtask(function () {
	        var wrapper = { _w: promise, _d: false }; // wrap
	        try {
	          then.call(value, _ctx($resolve, wrapper, 1), _ctx($reject, wrapper, 1));
	        } catch (e) {
	          $reject.call(wrapper, e);
	        }
	      });
	    } else {
	      promise._v = value;
	      promise._s = 1;
	      notify(promise, false);
	    }
	  } catch (e) {
	    $reject.call({ _w: promise, _d: false }, e); // wrap
	  }
	};

	// constructor polyfill
	if (!USE_NATIVE$1) {
	  // 25.4.3.1 Promise(executor)
	  $Promise = function Promise(executor) {
	    _anInstance(this, $Promise, PROMISE, '_h');
	    _aFunction(executor);
	    Internal.call(this);
	    try {
	      executor(_ctx($resolve, this, 1), _ctx($reject, this, 1));
	    } catch (err) {
	      $reject.call(this, err);
	    }
	  };
	  // eslint-disable-next-line no-unused-vars
	  Internal = function Promise(executor) {
	    this._c = [];             // <- awaiting reactions
	    this._a = undefined;      // <- checked in isUnhandled reactions
	    this._s = 0;              // <- state
	    this._d = false;          // <- done
	    this._v = undefined;      // <- value
	    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	    this._n = false;          // <- notify
	  };
	  Internal.prototype = _redefineAll($Promise.prototype, {
	    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	    then: function then(onFulfilled, onRejected) {
	      var reaction = newPromiseCapability(_speciesConstructor(this, $Promise));
	      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	      reaction.fail = typeof onRejected == 'function' && onRejected;
	      reaction.domain = isNode$1 ? process$2.domain : undefined;
	      this._c.push(reaction);
	      if (this._a) this._a.push(reaction);
	      if (this._s) notify(this, false);
	      return reaction.promise;
	    },
	    // 25.4.5.1 Promise.prototype.catch(onRejected)
	    'catch': function (onRejected) {
	      return this.then(undefined, onRejected);
	    }
	  });
	  OwnPromiseCapability = function () {
	    var promise = new Internal();
	    this.promise = promise;
	    this.resolve = _ctx($resolve, promise, 1);
	    this.reject = _ctx($reject, promise, 1);
	  };
	  _newPromiseCapability.f = newPromiseCapability = function (C) {
	    return C === $Promise || C === Wrapper
	      ? new OwnPromiseCapability(C)
	      : newGenericPromiseCapability(C);
	  };
	}

	_export(_export.G + _export.W + _export.F * !USE_NATIVE$1, { Promise: $Promise });
	_setToStringTag($Promise, PROMISE);
	_setSpecies(PROMISE);
	Wrapper = _core[PROMISE];

	// statics
	_export(_export.S + _export.F * !USE_NATIVE$1, PROMISE, {
	  // 25.4.4.5 Promise.reject(r)
	  reject: function reject(r) {
	    var capability = newPromiseCapability(this);
	    var $$reject = capability.reject;
	    $$reject(r);
	    return capability.promise;
	  }
	});
	_export(_export.S + _export.F * (_library ), PROMISE, {
	  // 25.4.4.6 Promise.resolve(x)
	  resolve: function resolve(x) {
	    return _promiseResolve( this === Wrapper ? $Promise : this, x);
	  }
	});
	_export(_export.S + _export.F * !(USE_NATIVE$1 && _iterDetect(function (iter) {
	  $Promise.all(iter)['catch'](empty);
	})), PROMISE, {
	  // 25.4.4.1 Promise.all(iterable)
	  all: function all(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var resolve = capability.resolve;
	    var reject = capability.reject;
	    var result = _perform(function () {
	      var values = [];
	      var index = 0;
	      var remaining = 1;
	      _forOf(iterable, false, function (promise) {
	        var $index = index++;
	        var alreadyCalled = false;
	        values.push(undefined);
	        remaining++;
	        C.resolve(promise).then(function (value) {
	          if (alreadyCalled) return;
	          alreadyCalled = true;
	          values[$index] = value;
	          --remaining || resolve(values);
	        }, reject);
	      });
	      --remaining || resolve(values);
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  },
	  // 25.4.4.4 Promise.race(iterable)
	  race: function race(iterable) {
	    var C = this;
	    var capability = newPromiseCapability(C);
	    var reject = capability.reject;
	    var result = _perform(function () {
	      _forOf(iterable, false, function (promise) {
	        C.resolve(promise).then(capability.resolve, reject);
	      });
	    });
	    if (result.e) reject(result.v);
	    return capability.promise;
	  }
	});

	_export(_export.P + _export.R, 'Promise', { 'finally': function (onFinally) {
	  var C = _speciesConstructor(this, _core.Promise || _global.Promise);
	  var isFunction = typeof onFinally == 'function';
	  return this.then(
	    isFunction ? function (x) {
	      return _promiseResolve(C, onFinally()).then(function () { return x; });
	    } : onFinally,
	    isFunction ? function (e) {
	      return _promiseResolve(C, onFinally()).then(function () { throw e; });
	    } : onFinally
	  );
	} });

	// https://github.com/tc39/proposal-promise-try




	_export(_export.S, 'Promise', { 'try': function (callbackfn) {
	  var promiseCapability = _newPromiseCapability.f(this);
	  var result = _perform(callbackfn);
	  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
	  return promiseCapability.promise;
	} });

	var promise = _core.Promise;

	var promise$1 = promise;

	function _arrayWithHoles(arr) {
	  if (isArray$1(arr)) return arr;
	}

	var arrayWithHoles = _arrayWithHoles;

	var core_getIterator = _core.getIterator = function (it) {
	  var iterFn = core_getIteratorMethod(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return _anObject(iterFn.call(it));
	};

	var getIterator = core_getIterator;

	var getIterator$1 = getIterator;

	var ITERATOR$4 = _wks('iterator');

	var core_isIterable = _core.isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR$4] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || _iterators.hasOwnProperty(_classof(O));
	};

	var isIterable = core_isIterable;

	var isIterable$1 = isIterable;

	function _iterableToArrayLimit(arr, i) {
	  if (!(isIterable$1(Object(arr)) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
	    return;
	  }

	  var _arr = [];
	  var _n = true;
	  var _d = false;
	  var _e = undefined;

	  try {
	    for (var _i = getIterator$1(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);

	      if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;
	    _e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }

	  return _arr;
	}

	var iterableToArrayLimit = _iterableToArrayLimit;

	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance");
	}

	var nonIterableRest = _nonIterableRest;

	function _slicedToArray(arr, i) {
	  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
	}

	var slicedToArray = _slicedToArray;

	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);

	  while (fromRight ? index-- : ++index < length) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }

	  return -1;
	}

	var _baseFindIndex = baseFindIndex;

	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}

	var _baseIsNaN = baseIsNaN;

	/**
	 * A specialized version of `_.indexOf` which performs strict equality
	 * comparisons of values, i.e. `===`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function strictIndexOf(array, value, fromIndex) {
	  var index = fromIndex - 1,
	      length = array.length;

	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }

	  return -1;
	}

	var _strictIndexOf = strictIndexOf;

	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */

	function baseIndexOf(array, value, fromIndex) {
	  return value === value ? _strictIndexOf(array, value, fromIndex) : _baseFindIndex(array, _baseIsNaN, fromIndex);
	}

	var _baseIndexOf = baseIndexOf;

	/** `Object#toString` result references. */

	var stringTag$2 = '[object String]';
	/**
	 * Checks if `value` is classified as a `String` primitive or object.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	 * @example
	 *
	 * _.isString('abc');
	 * // => true
	 *
	 * _.isString(1);
	 * // => false
	 */

	function isString(value) {
	  return typeof value == 'string' || !isArray_1(value) && isObjectLike_1(value) && _baseGetTag(value) == stringTag$2;
	}

	var isString_1 = isString;

	var _stringWs = '\x09\x0A\x0B\x0C\x0D\x20\xA0\u1680\u180E\u2000\u2001\u2002\u2003' +
	  '\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

	var space = '[' + _stringWs + ']';
	var non = '\u200b\u0085';
	var ltrim = RegExp('^' + space + space + '*');
	var rtrim = RegExp(space + space + '*$');

	var exporter = function (KEY, exec, ALIAS) {
	  var exp = {};
	  var FORCE = _fails(function () {
	    return !!_stringWs[KEY]() || non[KEY]() != non;
	  });
	  var fn = exp[KEY] = FORCE ? exec(trim) : _stringWs[KEY];
	  if (ALIAS) exp[ALIAS] = fn;
	  _export(_export.P + _export.F * FORCE, 'String', exp);
	};

	// 1 -> String#trimLeft
	// 2 -> String#trimRight
	// 3 -> String#trim
	var trim = exporter.trim = function (string, TYPE) {
	  string = String(_defined(string));
	  if (TYPE & 1) string = string.replace(ltrim, '');
	  if (TYPE & 2) string = string.replace(rtrim, '');
	  return string;
	};

	var _stringTrim = exporter;

	var $parseInt = _global.parseInt;
	var $trim = _stringTrim.trim;

	var hex = /^[-+]?0[xX]/;

	var _parseInt = $parseInt(_stringWs + '08') !== 8 || $parseInt(_stringWs + '0x16') !== 22 ? function parseInt(str, radix) {
	  var string = $trim(String(str), 3);
	  return $parseInt(string, (radix >>> 0) || (hex.test(string) ? 16 : 10));
	} : $parseInt;

	// 18.2.5 parseInt(string, radix)
	_export(_export.G + _export.F * (parseInt != _parseInt), { parseInt: _parseInt });

	var _parseInt$1 = _core.parseInt;

	var _parseInt$2 = _parseInt$1;

	/** Used as references for various `Number` constants. */

	var NAN = 0 / 0;
	/** Used to match leading and trailing whitespace. */

	var reTrim = /^\s+|\s+$/g;
	/** Used to detect bad signed hexadecimal string values. */

	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	/** Used to detect binary string values. */

	var reIsBinary = /^0b[01]+$/i;
	/** Used to detect octal string values. */

	var reIsOctal = /^0o[0-7]+$/i;
	/** Built-in method references without a dependency on `root`. */

	var freeParseInt = _parseInt$2;
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */

	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }

	  if (isSymbol_1(value)) {
	    return NAN;
	  }

	  if (isObject_1(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject_1(other) ? other + '' : other;
	  }

	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }

	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
	}

	var toNumber_1 = toNumber;

	/** Used as references for various `Number` constants. */

	var INFINITY$2 = 1 / 0,
	    MAX_INTEGER = 1.7976931348623157e+308;
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */

	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }

	  value = toNumber_1(value);

	  if (value === INFINITY$2 || value === -INFINITY$2) {
	    var sign = value < 0 ? -1 : 1;
	    return sign * MAX_INTEGER;
	  }

	  return value === value ? value : 0;
	}

	var toFinite_1 = toFinite;

	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */

	function toInteger(value) {
	  var result = toFinite_1(value),
	      remainder = result % 1;
	  return result === result ? remainder ? result - remainder : result : 0;
	}

	var toInteger_1 = toInteger;

	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */

	function baseValues(object, props) {
	  return _arrayMap(props, function (key) {
	    return object[key];
	  });
	}

	var _baseValues = baseValues;

	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */

	function values(object) {
	  return object == null ? [] : _baseValues(object, keys_1(object));
	}

	var values_1 = values;

	/* Built-in method references for those with the same name as other `lodash` methods. */

	var nativeMax = Math.max;
	/**
	 * Checks if `value` is in `collection`. If `collection` is a string, it's
	 * checked for a substring of `value`, otherwise
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * is used for equality comparisons. If `fromIndex` is negative, it's used as
	 * the offset from the end of `collection`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object|string} collection The collection to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} [fromIndex=0] The index to search from.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	 * @returns {boolean} Returns `true` if `value` is found, else `false`.
	 * @example
	 *
	 * _.includes([1, 2, 3], 1);
	 * // => true
	 *
	 * _.includes([1, 2, 3], 1, 2);
	 * // => false
	 *
	 * _.includes({ 'a': 1, 'b': 2 }, 1);
	 * // => true
	 *
	 * _.includes('abcd', 'bc');
	 * // => true
	 */

	function includes(collection, value, fromIndex, guard) {
	  collection = isArrayLike_1(collection) ? collection : values_1(collection);
	  fromIndex = fromIndex && !guard ? toInteger_1(fromIndex) : 0;
	  var length = collection.length;

	  if (fromIndex < 0) {
	    fromIndex = nativeMax(length + fromIndex, 0);
	  }

	  return isString_1(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && _baseIndexOf(collection, value, fromIndex) > -1;
	}

	var includes_1 = includes;

	var CONTENT_TYPE_JSON = 'application/json';
	var CONTENT_TYPE_MULTIPART_FORM = 'multipart/form-data';
	var handleErrors = function handleErrors(_ref) {
	  var _ref2 = slicedToArray(_ref, 4),
	      ok = _ref2[0],
	      response = _ref2[1],
	      status = _ref2[2],
	      statusText = _ref2[3];

	  if (!ok) {
	    var errorMessage = response.error && response.error.message || response.errorMessage || 'An error has occurred';
	    var error = new Error(errorMessage);
	    error.response = response;
	    error.status = status;
	    error.statusText = statusText;
	    throw error;
	  }

	  return response;
	};
	var handlePromise = function handlePromise(response) {
	  var contentType = response.headers && response.headers.get('Content-Type');

	  if (includes_1(contentType, CONTENT_TYPE_JSON)) {
	    return promise$1.all([response.ok, response.json(), response.status, response.statusText]);
	  }

	  return promise$1.all([response.ok, response.text(), response.status, response.statusText]);
	};

	// @ts-check
	var LOCAL_STORAGE_SUPPORT = Boolean(typeof window !== 'undefined' && window.localStorage);
	var SESSION_STORAGE_SUPPORT = Boolean(typeof window !== 'undefined' && window.sessionStorage);
	/**
	 * set a cookie
	 *
	 * @param {string}  key - cookie key
	 * @param {string}  value - cookie value
	 * @param {number} durationDays - expiration date
	 */

	function setCookie(key, value, durationDays) {
	  var cookieString = "".concat(key, "=").concat(value);

	  if (durationDays) {
	    var d = new Date();
	    d.setTime(d.getTime() + durationDays * 24 * 3600 * 1000);
	    cookieString += "; expires=".concat(d.toUTCString());
	  }

	  document.cookie = "".concat(cookieString, "; path=/");
	}
	/**
	 * get a cookie
	 *
	 * @param {string}  key - name of cookie to retrieve
	 * @returns {string}
	 */

	function getCookie(key) {
	  var name = "".concat(key, "=");
	  var ca = document.cookie.split(';');

	  for (var i = 0; i < ca.length; i += 1) {
	    var c = ca[i];

	    while (c.charAt(0) === ' ') {
	      c = c.substring(1);
	    }

	    if (c.indexOf(name) === 0) {
	      return c.substring(name.length, c.length);
	    }
	  }

	  return '';
	}
	/**
	 * delete a cookie
	 *
	 * @param {string}  key - name of cookie
	 */

	function deleteCookie(key) {
	  setCookie(key, '', -1);
	}
	/**
	 * get a value from localStorage
	 *
	 * @param {string}  key - name of property to retrieve
	 * @returns {string}
	 */

	function getLocalStorage(key) {
	  if (LOCAL_STORAGE_SUPPORT) {
	    return window.localStorage.getItem(key);
	  }

	  return getCookie(key);
	}
	/**
	 * set a value in localStorage
	 *
	 * @param {string}  key - name of property
	 * @param {string}  value - value of property
	 */

	function setLocalStorage(key, value) {
	  if (LOCAL_STORAGE_SUPPORT) {
	    window.localStorage.setItem(key, value);
	  } else {
	    setCookie(key, value, 365);
	  }
	}
	/**
	 * remove a value in localStorage
	 *
	 * @param {string}  key - name of property
	 */

	function deleteLocalStorage(key) {
	  if (LOCAL_STORAGE_SUPPORT) {
	    window.localStorage.removeItem(key);
	  } else {
	    deleteCookie(key);
	  }
	}
	/**
	 * set a value in sessionStorage
	 *
	 * @param {string}  key - name of property
	 * @param {string}  value - value of property
	 */

	function setSessionStorage(key, value) {
	  if (SESSION_STORAGE_SUPPORT) {
	    window.sessionStorage.setItem(key, value);
	  } else {
	    // @ts-ignore An argument for 'durationDays' was not provided
	    setCookie(key, value);
	  }
	}
	/**
	 * get a value from sessionStorage
	 *
	 * @param {string}  key - name of property to retrieve
	 * @returns {string}
	 */

	function getSessionStorage(key) {
	  if (SESSION_STORAGE_SUPPORT) {
	    return window.sessionStorage.getItem(key);
	  }

	  return getCookie(key);
	}
	/**
	 * remove a value in sessionStorage
	 *
	 * @param {string}  key - name of property
	 */

	function deleteSessionStorage(key) {
	  if (SESSION_STORAGE_SUPPORT) {
	    window.sessionStorage.removeItem(key);
	  } else {
	    deleteCookie(key);
	  }
	}
	/**
	 * @param {string} key
	 * @param {string} value
	 */

	function setAllStorage(key, value) {
	  // @ts-ignore An argument for 'durationDays' was not provided
	  setCookie(key, value);
	  setLocalStorage(key, value);
	}
	/**
	 * @param {string} key
	 * @returns {string}
	 */

	function getAllStorage(key) {
	  var cookieValue = getCookie(key);
	  var localStorageValue = getLocalStorage(key);

	  if (cookieValue) {
	    return cookieValue;
	  }

	  if (localStorageValue) {
	    return localStorageValue;
	  }

	  return null;
	}
	/**
	 * @param {string} key
	 */

	function deleteAllStorage(key) {
	  deleteLocalStorage(key);
	  deleteCookie(key);
	}

	function ownKeys(object, enumerableOnly) { var keys = keys$1(object); if (getOwnPropertySymbols$1) { var symbols = getOwnPropertySymbols$1(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return getOwnPropertyDescriptor$1(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { defineProperty$3(target, key, source[key]); }); } else if (getOwnPropertyDescriptors$1) { defineProperties$1(target, getOwnPropertyDescriptors$1(source)); } else { ownKeys(source).forEach(function (key) { defineProperty$1(target, key, getOwnPropertyDescriptor$1(source, key)); }); } } return target; }
	var Method = {
	  get: 'GET',
	  post: 'POST',
	  put: 'PUT',
	  patch: 'PATCH',
	  delete: 'DELETE'
	};
	var CSRF_TOKEN_HEADER = 'x-csrf-token';
	var CSRF_TOKEN_COOKIE = 'CSRF-TOKEN';

	var request = function request(url, options) {
	  return fetch(url, options).then(handlePromise).then(handleErrors);
	};

	var get$1 = function get(url) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	  var finalHeaders = _objectSpread({
	    'Content-Type': CONTENT_TYPE_JSON
	  }, headers);

	  var finalOptions = _objectSpread({
	    method: Method.get,
	    credentials: 'same-origin',
	    headers: finalHeaders
	  }, options);

	  return request(url, finalOptions);
	};

	var post = function post(url) {
	  var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

	  var combinedHeaders = _objectSpread(defineProperty$3({
	    'Content-Type': body instanceof FormData ? CONTENT_TYPE_MULTIPART_FORM : CONTENT_TYPE_JSON
	  }, CSRF_TOKEN_HEADER, getCookie(CSRF_TOKEN_COOKIE)), headers);

	  var finalHeaders = pickBy_1(combinedHeaders, function (value) {
	    return value !== undefined;
	  });

	  var finalBody = finalHeaders['Content-Type'] === CONTENT_TYPE_JSON ? stringify$1(body) : body;

	  var finalOptions = _objectSpread({
	    method: Method.post,
	    credentials: 'same-origin',
	    body: finalBody,
	    headers: finalHeaders
	  }, options);

	  return request(url, finalOptions);
	};

	var put = function put(url) {
	  var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

	  var finalHeaders = _objectSpread(defineProperty$3({
	    'Content-Type': CONTENT_TYPE_JSON
	  }, CSRF_TOKEN_HEADER, getCookie(CSRF_TOKEN_COOKIE)), headers);

	  var finalBody = stringify$1(body);

	  var finalOptions = _objectSpread({
	    method: Method.put,
	    credentials: 'same-origin',
	    body: finalBody,
	    headers: finalHeaders
	  }, options);

	  return request(url, finalOptions);
	};

	var patch = function patch(url) {
	  var body = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var headers = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

	  var finalHeaders = _objectSpread(defineProperty$3({
	    'Content-Type': CONTENT_TYPE_JSON
	  }, CSRF_TOKEN_HEADER, getCookie(CSRF_TOKEN_COOKIE)), headers);

	  var finalBody = stringify$1(body);

	  var finalOptions = _objectSpread({
	    method: Method.patch,
	    credentials: 'same-origin',
	    body: finalBody,
	    headers: finalHeaders
	  }, options);

	  return request(url, finalOptions);
	};

	var deleteMethod = function deleteMethod(url) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

	  var finalHeaders = _objectSpread(defineProperty$3({
	    'Content-Type': CONTENT_TYPE_JSON
	  }, CSRF_TOKEN_HEADER, getCookie(CSRF_TOKEN_COOKIE)), headers);

	  var finalOptions = _objectSpread({
	    method: Method.delete,
	    credentials: 'same-origin',
	    headers: finalHeaders
	  }, options);

	  return request(url, finalOptions);
	};

	var ApiService = {
	  request: request,
	  get: get$1,
	  post: post,
	  put: put,
	  patch: patch,
	  delete: deleteMethod
	};

	/**
	 * @param {object} payload
	 */
	function pushToDataLayer(payload) {
	  if (window.analytics && window.dataLayer) {
	    window.dataLayer.push(payload);
	  }
	}
	/**
	 *
	 */


	function setGTMLoggedIn() {
	  pushToDataLayer({
	    LoginStatus: 'Logged In'
	  });
	}
	/**
	 *
	 */

	function setGTMLoggedOut() {
	  pushToDataLayer({
	    LoginStatus: 'Not Logged In'
	  });
	}

	var STATUS_CODES = {
	  // CONTINUE: 100,
	  // SWITCHING_PROTOCOLS: 101,
	  // PROCESSING: 102,
	  // EARLY_HINTS: 103,
	  OK: 200,
	  CREATED: 201,
	  ACCEPTED: 202,
	  // NON_AUTHORITATIVE_INFORMATION: 203,
	  // NO_CONTENT: 204,
	  // RESET_CONTENT: 205,
	  // PARTIAL_CONTENT: 206,
	  // MULTI_STATUS: 207,
	  // ALREADY_REPORTED: 208,
	  // IM_USED: 226,
	  // MULTIPLE_CHOICES: 300,
	  MOVED_PERMANENTLY: 301,
	  // FOUND: 302,
	  // SEE_OTHER: 303,
	  // NOT_MODIFIED: 304,
	  // USE_PROXY: 305,
	  // SWITCH_PROXY: 306,
	  // TEMPORARY_REDIRECT: 307,
	  // PERMANENT_REDIRECT: 308,
	  BAD_REQUEST: 400,
	  UNAUTHORIZED: 401,
	  // PAYMENT_REQUIRED: 402,
	  FORBIDDEN: 403,
	  NOT_FOUND: 404,
	  // METHOD_NOT_ALLOWED: 405,
	  NOT_ACCEPTABLE: 406,
	  // PROXY_AUTHENTICATION_REQUIRED: 407,
	  // REQUEST_TIMEOUT: 408,
	  // CONFLICT: 409,
	  // GONE: 410,
	  // LENGTH_REQUIRED: 411,
	  // PRECONDITION_FAILED: 412,
	  // PAYLOAD_TOO_LARGE: 413,
	  // URI_TOO_LONG: 414,
	  // UNSUPPORTED_MEDIA_TYPE: 415,
	  // RANGE_NOT_SATISFIABLE: 416,
	  // EXPECTATION_FAILED: 417,
	  // IM_A_TEAPOT: 418,
	  // MISDIRECTED_REQUEST: 421,
	  // UNPROCESSABLE_ENTITY: 422,
	  // LOCKED: 423,
	  // FAILED_DEPENDENCY: 424,
	  // TOO_EARLY: 425,
	  // UPGRADE_REQUIRED: 426,
	  // PRECONDITION_REQUIRED: 428,
	  TOO_MANY_REQUESTS: 429,
	  // REQUEST_HEADER_FIELDS_TOO_LARGE: 431,
	  // UNAVAILABLE_FOR_LEGAL_REASONS: 451,
	  INTERNAL_SERVER_ERROR: 500,
	  // NOT_IMPLEMENTED: 501,
	  BAD_GATEWAY: 502,
	  SERVICE_UNAVAILABLE: 503,
	  GATEWAY_TIMEOUT: 504 // HTTP_VERSION_NOT_SUPPORTED: 505,
	  // VARIANT_ALSO_NEGOTIATES: 506,
	  // INSUFFICIENT_STORAGE: 507,
	  // LOOP_DETECTED: 508,
	  // NOT_EXTENDED: 510,
	  // NETWORK_AUTHENTICATION_REQUIRED: 511,

	};

	// or if reason doesn't exist, sends the message that comes from backend, or default error message

	/**
	 * An constant that stores error message and type in key value pair
	 *
	 * @type {{
	 *  'facebook-missing-email': string,
	 *  user_locked: string,
	 *  default: string,
	 *  invalid_password: string,
	 *  invalid_email: string
	 * }}
	 */

	var ERROR_MESSAGE = {
	  invalid_password: 'Your email and password do not match.',
	  invalid_email: 'You have entered an invalid email.',
	  user_locked: 'Looks like you have forgotten your password. Please click the forgot password link above to reset your password and continue.',
	  'facebook-missing-email': 'You must provide Zola access to your Facebook email address to create your account.',
	  default: 'There was a problem processing your request. Please try again or contact customer support for assistance.'
	};
	/**
	 * Construct an error message base on error message types. If no match for the error type, return default.
	 *
	 * @param {ErrorType} error
	 * @returns {string}
	 */

	function getDetailedMessage(error) {
	  var errorMessage = error && error.category && ERROR_MESSAGE[error.category.reason];
	  return errorMessage || ERROR_MESSAGE.default;
	}
	/** @typedef {object} ErrorType
	 * @property {string} name
	 * @property {string} message
	 * @property {string} [stack]
	 * // augmented
	 * @property {ResponseType} [response]
	 * @property {string} [detailedMessage]
	 * @property {{ reason: string }} [category]
	 */

	/** @typedef ResponseType
	 * @property {string|number} status
	 * @property {string} message
	 * @property {string} statusText
	 */

	/**
	 * Construct an error message that contains the error response and user friendly message
	 *
	 * @param {ErrorType} error
	 */

	function createError(error) {
	  // @ts-ignore Argument of type 'ResponseType' is not assignable to parameter of type 'ErrorType'. (BUG?)
	  var errorData = assign$1({
	    detailedMessage: getDetailedMessage(error.response)
	  }, error);

	  throw errorData;
	}
	/**
	 * Construct an error object if the response is a error, otherwise return the same response
	 *
	 * @param {ResponseType} response
	 * @returns {ResponseType}
	 */


	function checkResponse(response) {
	  if (response.status === 'error') {
	    // @ts-ignore Argument of type 'ResponseType' is not assignable to parameter of type 'ErrorType'.
	    createError(response);
	  }

	  return response;
	}
	/**
	 * Construct an error object if the status is a error, otherwise return the same response
	 *
	 * @param {ResponseType} response
	 */

	function checkWAFErrors(response) {
	  if (response.status === STATUS_CODES.FORBIDDEN) {
	    /** @type {ErrorType} */
	    var error = new Error(response.statusText);
	    error.response = response;
	    error.detailedMessage = 'Please contact support@zola.com and we will assist you.';
	    throw error;
	  }

	  if (response.status === STATUS_CODES.NOT_ACCEPTABLE) {
	    /** @type {ErrorType} */
	    var _error = new Error(response.statusText);

	    _error.response = response;
	    _error.detailedMessage = 'Your account has been locked due to too many failed login attempts. Please wait 1 hour and try again.';
	    throw _error;
	  }

	  if (response.status === STATUS_CODES.TOO_MANY_REQUESTS) {
	    /** @type {ErrorType} */
	    var _error2 = new Error(response.statusText);

	    _error2.response = response;
	    _error2.detailedMessage = 'Please wait a few moments ...';
	    throw _error2;
	  }
	}
	/** @typedef LoginSuccessAction
	 * @property {object} payload
	 * @property {string} payload.email
	 * @property {string} type
	 */

	/**
	 * Action Creator: dispatch LOGIN_SUCCESS event
	 *
	 * @param {string} email
	 * @returns {LoginSuccessAction}
	 */

	function loginSuccess(email) {
	  return {
	    type: LOGIN_SUCCESS,
	    payload: {
	      email: email
	    }
	  };
	}
	/** @typedef LoginFailureAction
	 * @property {object} payload
	 * @property {string} payload.statusText
	 * @property {string | number} payload.status
	 * @property {string} type
	 */

	/**
	 * Action Creator: dispatch LOGIN_FAILURE event
	 *
	 * @param {ErrorType} error
	 * @returns {LoginFailureAction}
	 */

	function loginFailure(error) {
	  return {
	    type: LOGIN_FAILURE,
	    payload: {
	      status: error.response.status,
	      statusText: error.response.statusText
	    }
	  };
	}
	/** @typedef LoginRequestAction
	 * @property {string} type
	 */

	/**
	 * Action Creator: dispatch LOGIN_REQUEST event
	 *
	 * @returns {LoginRequestAction}
	 */

	function loginRequest() {
	  return {
	    type: LOGIN_REQUEST
	  };
	}
	/** @typedef LogoutAction
	 * @property {string} type
	 */

	/**
	 * Action Creator: dispatch LOGOUT event
	 *
	 * @returns {LogoutAction}
	 */

	function logout() {
	  return {
	    type: LOGOUT
	  };
	}
	/**
	 * Send login request to the server. Notify GTM the user is logged in
	 *
	 * @param {object} loginFormRequest
	 * @returns {Promise<object>}
	 */

	function sendLoginRequest(loginFormRequest) {
	  return ApiService.post('/website-nav/web-api/v1/auth/login', loginFormRequest).then(function (data) {
	    setGTMLoggedIn();
	    return data;
	  }).catch(function (error) {
	    checkWAFErrors(error);
	    throw createError(error);
	  });
	}
	/**
	 * Send signup request to the server. Notify GTM the user is logged in
	 *
	 * @param {object} createUserRequest
	 * @returns {Promise<object>}
	 */

	function sendSignupRequest(createUserRequest) {
	  return ApiService.post('/website-nav/web-api/v1/user/create', createUserRequest).then(function (data) {
	    setAllStorage('zolaUserCreatedAt', new Date().toISOString());
	    setGTMLoggedIn();
	    return data;
	  }).catch(function (error) {
	    throw createError(error);
	  });
	}
	/**
	 * Send logout request to the server. Notify GTM the user is logged out
	 *
	 * @returns {Promise<void>}
	 */

	function sendSignOutRequest() {
	  return ApiService.get('/website-nav/web-api/v1/auth/signout').then(function () {
	    setGTMLoggedOut();
	  }).catch(function (error) {
	    throw createError(error);
	  });
	}
	/**
	 * Send check email request to check if a email address is available.
	 *
	 * @param {string} email
	 * @returns {function(): Promise<object>}
	 */

	function checkEmail(email) {
	  return function () {
	    return ApiService.post("/website-nav/web-api/v1/user/email_available/".concat(email));
	  };
	}
	/**
	 * Send reset password request to reset user password.
	 *
	 * @param {object} createResetPasswordRequest
	 * @returns {function(): Promise<object>} reset password callback
	 */

	function sendResetPassword(createResetPasswordRequest) {
	  return function () {
	    return ApiService.post('/website-nav/web-api/v1/user/reset_password', createResetPasswordRequest);
	  };
	}
	/**
	 * @param {object} fbLoginRequest
	 * @returns {Promise<object>}
	 */

	function sendFacebookLoginRequest(fbLoginRequest) {
	  return ApiService.post('/website-nav/web-api/v1/auth/facebook-login', fbLoginRequest);
	}
	/**
	 * @param {object} appleLoginRequest
	 * @returns {Promise<object>}
	 */

	function sendAppleLoginRequest(appleLoginRequest) {
	  return ApiService.post('/website-nav/web-api/v1/auth/apple-login', appleLoginRequest);
	}

	// @ts-check

	/**
	 * get query param by name
	 *
	 * @function getQueryParam
	 * @param {string}  paramName - name of parameter to retrieve
	 * @param {boolean} trimValue - should trim string value
	 * @returns {string}
	 */
	function getQueryParam(paramName) {
	  var trimValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
	  var queryString = window.location.search.trim();

	  if (queryString.length > 1) {
	    var queryStringParts = queryString.substring(1).split('&');

	    for (var i = 0; i < queryStringParts.length; i += 1) {
	      var partPair = queryStringParts[i].split('=');

	      if (partPair[0] === paramName) {
	        var paramValue = decodeURIComponent(partPair[1]);
	        return trimValue ? paramValue.trim() : paramValue;
	      }
	    }
	  }

	  return '';
	}

	// @ts-check
	var defaultNegative = function defaultNegative() {
	  return null;
	};
	/**
	 * util for rendering jsx if conditional is met
	 *
	 * @param {boolean} conditional - conditional to evaluate
	 * @param {Function} affirmative - function to execute if conditional === true
	 * @param {Function} negative - function to execute if conditional === false
	 * @returns {*}
	 */


	function renderIf(conditional, affirmative) {
	  var negative = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultNegative;
	  return conditional ? affirmative() : negative();
	}

	var BUSINESS_UNIT = {
	  INSPIRATION: 'INSPIRATION',
	  // Deprecated: Use MARKETPLACE for marketplace couples
	  INVITATIONS: 'INVITATIONS',
	  MARKETPLACE: 'MARKETPLACE',
	  MARKETPLACE_COUPLES: 'MARKETPLACE_COUPLES',
	  // Deprecated: Use MARKETPLACE for marketplace couples
	  MARKETPLACE_VENDORS: 'MARKETPLACE_VENDORS',
	  REGISTRY: 'REGISTRY',
	  WEDDINGS: 'WEDDINGS',
	  WEDDING_REGISTRY: 'WEDDING_REGISTRY',
	  STORE: 'STORE',
	  PHOTOBOOK: 'PHOTOBOOK'
	};
	var COMPONENT = {
	  CHANGE_THE_DATE: 'CHANGE_THE_DATE',
	  DAY_OF_PAPER: 'DAY_OF_PAPER',
	  FAVORITE: 'FAVORITE',
	  HOLIDAY: 'HOLIDAY',
	  INQUIRY: 'INQUIRY',
	  INSPIRATION: 'INSPIRATION',
	  // Deprecated: Use MARKETPLACE for marketplace couples
	  INVITATIONS: 'INVITATIONS',
	  MARKETPLACE: 'MARKETPLACE',
	  MARKETPLACE_COUPLES: 'MARKETPLACE_COUPLES',
	  // Deprecated: Use MARKETPLACE for marketplace couples
	  MARKETPLACE_MATCH: 'MARKETPLACE_MATCH',
	  // Deprecated
	  MARKETPLACE_QUIZ: 'MARKETPLACE_QUIZ',
	  REAL_WEDDINGS: 'REAL_WEDDINGS',
	  REGISTRY: 'REGISTRY',
	  SAVE_THE_DATE: 'SAVE_THE_DATE',
	  THANK_YOU_CARDS: 'THANK_YOU_CARDS',
	  WEDDINGS: 'WEDDINGS',
	  WEDDING_CHECKLIST: 'WEDDING_CHECKLIST',
	  WEDDING_GUEST_LIST: 'WEDDING_GUEST_LIST',
	  WEDDING_PLANNING: 'WEDDING_PLANNING',
	  WEDDING_WEBSITE: 'WEDDING_WEBSITE',
	  // For marketplace vendors
	  BANDS_DJS: 'BANDS_DJS',
	  CAKES_DESSERTS: 'CAKES_DESSERTS',
	  CATERING: 'CATERING',
	  FLORIST: 'FLORIST',
	  HAIR_MAKEUP: 'HAIR_MAKEUP',
	  PHOTOGRAPHER: 'PHOTOGRAPHER',
	  VENUE: 'VENUE',
	  VIDEOGRAPHER: 'VIDEOGRAPHER',
	  STORE: 'STORE'
	};
	var onboardTrackingConstants = {
	  BUSINESS_UNIT: BUSINESS_UNIT,
	  COMPONENT: COMPONENT
	};

	/** @typedef PageContext
	 * @property {string} path
	 * @property {string} search
	 * @property {string} referrer
	 * @property {string} url
	 * @property {string} title
	 */

	/**
	 * @returns {PageContext}
	 */
	function getPageContext() {
	  return {
	    path: window.location.pathname,
	    search: window.location.search,
	    referrer: window && window.zola && window.zola.referrer || document.referrer,
	    url: window.location.href,
	    title: document.title
	  };
	}
	/**
	 * @param {string} eventName
	 * @param {object} payload
	 * @param {object} options
	 */


	function trackEvent(eventName, payload) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var optionsFinal = options || {};
	  optionsFinal.page = getPageContext();

	  if (window.analytics && window.analytics.track) {
	    window.analytics.track(eventName, payload, optionsFinal);
	  }
	}
	/**
	 * @param {string} eventName
	 * @param {object} payload
	 */

	function trackGoogleAnalyticsEvent(eventName, payload) {
	  var options = {
	    integrations: {
	      All: false,
	      'Google Analytics': true
	    }
	  };
	  trackEvent(eventName, payload, options);
	}

	/*
	  This file contains events from the Zola Web Analytics tracking plan related to onboarding:
	  'Onboarding Started' : https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=1706975390
	  'Onboarding Completed' : https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=533789771
	  'Onboarding Step Viewed' : https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=522474832
	  'Onboarding Step Completed' : https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=686083819
	  'Onboarding Step Skipped' : https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=1573913863
	*/

	/**
	 * @param {string} businessUnit
	 * @param {string} component
	 * @param {boolean} isExistingUser
	 */

	function trackOnboardingStarted(businessUnit, component) {
	  var isExistingUser = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

	  // isExistingUser used by some tags in GTM
	  if (window.analytics && window.dataLayer) {
	    window.dataLayer.push({
	      is_existing_user: isExistingUser
	    });
	  }

	  var payload = {
	    business_unit: businessUnit,
	    component: component
	  };
	  trackEvent('Onboarding Started', payload);
	}
	/**
	 * @param {string} businessUnit
	 * @param {string} component
	 * @param {object} options
	 */

	function trackOnboardingCompleted(businessUnit, component) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	  var defaultOptions = {
	    isExistingUser: null,
	    // Boolean value
	    weddingDate: null // Should be 'YYYY-MM-DD' format.

	  };

	  var combinedOptions = assign$1({}, defaultOptions, options);

	  var isExistingUser = combinedOptions.isExistingUser,
	      weddingDate = combinedOptions.weddingDate; // let { weddingDate } = combinedOptions;
	  // Impact Radius should only receive Registry First Onboarding Completed events

	  var registryFirst = businessUnit === 'WEDDING_REGISTRY' && !isExistingUser;
	  var clickId = getAllStorage('clickId');
	  var trackEventOptions = {
	    integrations: {
	      'Impact Radius': false
	    }
	  };

	  if (clickId && registryFirst) {
	    trackEventOptions.context = {
	      referrer: {
	        type: 'impactRadius',
	        id: clickId
	      }
	    };
	    trackEventOptions.integrations['Impact Radius'] = true;
	  } // TODO: Decide if the moment.js library should exist in zola-helpers. Date param must be formatted correctly when passed in.
	  // if (weddingDate) weddingDate = moment(weddingDate).format('YYYY-MM-DD');


	  if (window.analytics && window.dataLayer) {
	    window.dataLayer.push({
	      is_existing_user: isExistingUser,
	      wedding_date: weddingDate
	    });
	  }

	  var payload = {
	    business_unit: businessUnit,
	    component: component
	  };
	  trackEvent('Onboarding Completed', payload, trackEventOptions);
	}
	/**
	 * @param {string} businessUnit
	 * @param {string} component
	 * @param {string} stepKey
	 * @param {string} stepName
	 * @param {string} questionnaireVersion
	 * @param {string} stepUserResponse
	 */

	function trackOnboardingStepCompleted(businessUnit, component, stepKey, stepName, questionnaireVersion, stepUserResponse) {
	  var payload = {
	    business_unit: businessUnit,
	    component: component,
	    step_key: stepKey,
	    step_name: stepName,
	    questionnaire_version: questionnaireVersion
	  };

	  if (stepUserResponse) {
	    // To keep things backwards compatible
	    payload.step_user_response = stepUserResponse;
	  }

	  trackEvent('Onboarding Step Completed', payload);
	}
	/**
	 * @param {string} businessUnit
	 * @param {string} component
	 * @param {string} stepKey
	 * @param {string} stepName
	 * @param {string} questionnaireVersion
	 */

	function trackOnboardingStepViewed(businessUnit, component, stepKey, stepName, questionnaireVersion) {
	  var payload = {
	    business_unit: businessUnit,
	    component: component,
	    step_key: stepKey,
	    step_name: stepName,
	    questionnaire_version: questionnaireVersion
	  };
	  trackEvent('Onboarding Step Viewed', payload);
	}
	/**
	 * @param {string} businessUnit
	 * @param {string} component
	 * @param {string} stepKey
	 * @param {string} stepName
	 * @param {string} questionnaireVersion
	 */

	function trackOnboardingStepSkipped(businessUnit, component, stepKey, stepName, questionnaireVersion) {
	  var payload = {
	    business_unit: businessUnit,
	    component: component,
	    step_key: stepKey,
	    step_name: stepName,
	    questionnaire_version: questionnaireVersion
	  };
	  trackEvent('Onboarding Step Skipped', payload);
	}

	/**
	 * Calls the segment "Navigation Clicked" event
	 *
	 * @param {object} eventData
	 * @param {string} eventData.menu_item - Text of the link clicked
	 * @param {string} eventData.section - Predefined NAV_SECTION that represents a specific part of the nav
	 * @param {string} eventData.node_level_1 - Indicates the hierarchy of where the link was. Always applicable to clicks (ex: ‘CREATE REGISTRY’ has a Node Level 1 of REGISTRY)
	 * @param {string} eventData.node_level_2 - Typically null unless a click takes place on a secondary nav sub-menu item or tertiary nav menu item
	 * @param {number} eventData.row_position - 1-indexed (top to bottom)
	 * @param {number} eventData.column_positon - 1-indexed (left to right)
	 *
	 */
	// eslint-disable-next-line import/prefer-default-export

	function trackNavigationClicked(eventData) {
	  trackEvent('Navigation Clicked', eventData);
	}
	/**
	 * Calls the segment "Navigation Clicked" event
	 * Specifically for use on the Logo and a minimal navigation.
	 *
	 *  @function trackMinimalLogoClick
	 *  @returns {void}
	 */

	function trackMinimalLogoClick() {
	  /* eslint-disable @typescript-eslint/camelcase */
	  var eventData = {
	    menu_item: 'ZOLA',
	    section: 'MINIMAL',
	    node_level_1: 'ZOLA',
	    row_position: 1,
	    column_position: 1
	  };
	  /* eslint-enable @typescript-eslint/camelcase */

	  trackNavigationClicked(eventData);
	}

	// @ts-check

	/**
	 * Load JavaScript from source
	 * This helper comes from htmlScriptLoader.jsx in web-registry
	 * src is a String, attributes is an Object
	 *
	 * @param {string} src
	 * @param {object} attributes
	 */
	function loadSrc(src, attributes) {
	  var script = document.createElement('script');
	  script.src = src;
	  script.async = false;

	  if (attributes) {
	    var keys = keys$1(attributes);

	    keys.forEach(function (key) {
	      var value = attributes[key];
	      script.setAttribute(key, value);
	    });
	  }

	  document.body.appendChild(script);
	}

	// @ts-check
	var CTA_TYPES = {
	  BUTTON: 'BUTTON',
	  MARKETING_MODULE: 'MARKETING_MODULE'
	};
	/**
	 * @typedef {object} CtaEventDataType
	 * @property {string} [business_unit]  Business unit that is utilizing the CTA
	 * @property {string} cta_type Type of CTA
	 * @property {string} group_id Group identifier of the marketing module
	 * @property {string} cta_id Module identifier of the marketing module
	 * @property {number} position Position of module on the page top (1) down (2,3,4...)
	 * @property {string} location As defined: https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=290641458
	 * @property {string} section As defined: https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=290641458
	 * @property {string} cta Url user is redirected to upon click (null if module does not redirect users)
	 */

	/**
	 * @param {CtaEventDataType} eventData Event data
	 */

	function trackCtaClicked(eventData) {
	  trackEvent('CTA Clicked', eventData);
	}
	/**
	 * @param {CtaEventDataType} eventData Event data
	 */

	function trackCtaViewed(eventData) {
	  trackEvent('CTA Viewed', eventData);
	}

	/*
	  This file contains events from the Zola Web Analytics tracking plan related to shop products:
	  'Product Added': https://docs.google.com/spreadsheets/d/1He7KAgK_ryUca8TJgRAnowKXeFWxqq1csWZWZdyR3dc/edit#gid=164175519
	*/

	/**
	 * @param {object} eventData
	 */

	function trackProductAdded(eventData) {
	  if (!eventData) {
	    // eslint-disable-next-line no-console
	    console.warn('Product Added event called with falsy value.');
	    return;
	  }

	  if (keys$1(eventData).length === 0) // eslint-disable-next-line no-console
	    console.warn('Product Added event called without properties.'); // if the brand is not defined - clear it on the GTM data layer becuase we check for it to determine if the product added is a cash gift.

	  if (!eventData.brand && window.dataLayer && window.dataLayer.push) {
	    window.dataLayer.push({
	      brand: undefined
	    });
	  }

	  trackEvent('Product Added', eventData);
	}

	var isNotString = function isNotString(text) {
	  return !text || typeof text !== 'string';
	};

	// @ts-check
	/**
	 * capitalize the first letter of a string, rest to lower
	 *
	 * @function capitalizeFirst
	 * @param  {string} str
	 * @param  {number} lowerRest - lowerCase rest of string
	 * @returns {string}
	 * @example
	 * capitalizeFirst('some word') => 'Some word'
	 */

	var capitalizeFirst = function capitalizeFirst(str) {
	  var lowerRest = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  if (isNotString(str)) return '';
	  return "".concat(str[0].toUpperCase()).concat(lowerRest ? str.slice(1).toLowerCase() : str.slice(1));
	};

	// @ts-check
	/**
	 * convert a string to pascal casing and treat - and _ as word delimiters
	 *
	 * @function pascalize
	 * @param  {string} str
	 * @returns {string}
	 * @example
	 * pascalize('some_snake_case') => 'SomeSnakeCase'
	 * pascalize('some-pipe-case') => 'SomePipeCase'
	 * pascalize('some word') => 'SomeWord'
	 * pascalize('someCamelCase') => 'SomeCamelCase'
	 */

	var pascalize = function pascalize(str) {
	  if (isNotString(str)) return '';
	  return str.split(/[-_\s]/).map(capitalizeFirst) // TODO: is this very clever or a bug?
	  .join('');
	};

	// @ts-check
	/**
	 * convert a string to camel casing and treat - and _ as word delimiters
	 *
	 * @function camelize
	 * @param  {string} str
	 * @returns {string}
	 * @example
	 * camelize('some_snake_case') => 'someSnakeCase'
	 * camelize('some-pipe-case') => 'somePipeCase'
	 * camelize('some word') => 'someWord'
	 * camelize('SomePascalCase') => 'somePascalCase'
	 */

	var camelize = function camelize(str) {
	  if (isNotString(str)) return '';
	  var pascal = pascalize(str);
	  return "".concat(pascal[0].toLowerCase()).concat(pascal.slice(1));
	};

	// @ts-check
	/**
	 * capitalize all letters of a string
	 *
	 * @function capitalizeFirst
	 * @param  {string} str
	 * @returns {string}
	 * @example
	 * capitalizeAll('some word') => 'SOME WORD'
	 */

	var capitalizeAll = function capitalizeAll(str) {
	  if (isNotString(str)) return '';
	  return str.toUpperCase();
	};

	// @ts-check

	/**
	 * conditionally render the singular or plural of a noun
	 *
	 * @function pluralize
	 * @param  {string}   singularForm of word
	 * @param  {string}   pluralForm of word
	 * @param  {number}   count
	 * @param  {boolean}  [includeCount=true] whether to prepend the count
	 * @returns {string}   either the singular or plural noun
	 * @example
	 * pluralize('product', 'products', 1, false) => '1 product'
	 * pluralize('product', 'products', 4) => '4 products'
	 * pluralize('product', 'products', 4, false) => 'products'
	 */
	var pluralize = function pluralize(singularForm, pluralForm, count) {
	  var includeCount = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
	  var isSingular = count === 1 || count === -1;
	  var form = isSingular ? singularForm : pluralForm;
	  return includeCount ? "".concat(count, " ").concat(form) : form;
	};

	// @ts-check
	/**
	 * remove a subString from a string
	 *
	 * @function removeSubString
	 * @param  {string} str
	 * @param  {string} subStrToRemove
	 * @returns {string} replacementStr
	 * @example
	 * removeSubString("There is no curse in Elvish, Entish, or the tongues of Orcs for this treachery.", "Orcs", "Men")  =>
	 * 'There is no curse in Elvish, Entish, or the tongues of Men for this treachery.'
	 */

	var removeSubString = function removeSubString(str) {
	  var subStrToRemove = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  var replacementStr = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
	  if (isNotString(str)) return '';
	  return str.replace(subStrToRemove, replacementStr).trim();
	};

	// @ts-check
	/**
	 * truncate a string and add ellipses
	 *
	 * @function truncate
	 * @param  {string} str     - text string
	 * @param  {number} length  - # of characters to truncate to
	 * @param  {boolean} ell    - should append ellipses
	 * @returns {string}
	 * @example
	 * truncate("I thought up an ending for my book. 'And he lives happily ever after, till the end of his days.", 35, false) =>
	 * 'I thought up an ending for my book.'
	 */

	var truncate = function truncate(str, length) {
	  var ell = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	  if (isNotString(str)) return '';
	  var copyLength = length;
	  if (str.length <= copyLength) return str; // Remove character if last character would be space

	  if (str[length - 1] === ' ') copyLength -= 1;
	  var string = str.substring(0, copyLength);
	  return ell ? string.concat('…') : string;
	};

	var camelize$1 = camelize;
	var capitalizeAll$1 = capitalizeAll;
	var capitalizeFirst$1 = capitalizeFirst;
	var pascalize$1 = pascalize;
	var pluralize$1 = pluralize;
	var removeSubString$1 = removeSubString;
	var truncate$1 = truncate;

	/**
	 * @returns {boolean}
	 */
	function detectMobileDevice() {
	  if (navigator.userAgent.match(/Android/i) || navigator.userAgent.match(/webOS/i) || navigator.userAgent.match(/iPhone/i) || navigator.userAgent.match(/iPad/i) || navigator.userAgent.match(/iPod/i) || navigator.userAgent.match(/BlackBerry/i) || navigator.userAgent.match(/Windows Phone/i) || navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1 // to detect iPad iOS 13 or later
	  ) {
	      return true;
	    }

	  return false;
	}
	/**
	 * @returns {string}
	 */

	function getMobileOperatingSystem() {
	  var userAgent = navigator.userAgent || navigator.vendor || window.opera; // Windows Phone must come first because its UA also contains "Android"

	  if (/windows phone/i.test(userAgent)) {
	    return 'Windows Phone';
	  }

	  if (/android/i.test(userAgent)) {
	    return 'Android';
	  }

	  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
	    return 'iOS';
	  }

	  return 'unknown';
	}
	/**
	 * @returns {boolean}
	 */

	function detectIOS() {
	  return getMobileOperatingSystem() === 'iOS';
	}
	/**
	 * @returns {boolean}
	 */

	function detectAndroid() {
	  return getMobileOperatingSystem() === 'Android';
	} // https://developer.mozilla.org/en-US/docs/Web/HTTP/Browser_detection_using_the_user_agent

	/**
	 * @returns {boolean}
	 */

	function detectTouchScreen() {
	  var hasTouchScreen = false;

	  if ('maxTouchPoints' in navigator) {
	    hasTouchScreen = navigator.maxTouchPoints > 0;
	  } else if ('msMaxTouchPoints' in navigator) {
	    hasTouchScreen = navigator.msMaxTouchPoints > 0;
	  } else {
	    var mQ = window.matchMedia && matchMedia('(pointer:coarse)');

	    if (mQ && mQ.media === '(pointer:coarse)') {
	      hasTouchScreen = !!mQ.matches;
	    } else if ('orientation' in window) {
	      hasTouchScreen = true; // deprecated, but good fallback
	    } else {
	      // Only as a last resort, fall back to user agent sniffing
	      hasTouchScreen = detectMobileDevice();
	    }
	  }

	  return hasTouchScreen;
	}

	// @ts-check

	/**
	 * insert at index if conditional is met
	 * const arr = [
	 *  ...insertInArrayIf(boolean, { key: prop }),
	 *  { key: prop },
	 * ];
	 *
	 * @function insertInArrayIf
	 * @param {string}  condition - boolean evaluation
	 * @param {object[]} elements - the elements being added to the array
	 * @returns {object[]}
	 */
	function insertInArrayIf(condition) {
	  for (var _len = arguments.length, elements = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    elements[_key - 1] = arguments[_key];
	  }

	  return condition ? elements : [];
	}

	// @ts-check
	var XS_MOBILE_MAX = 480;
	var MOBILE_MAX = 767;
	var TABLET_MIN = 768;
	var TABLET_MAX = 991;
	var DESKTOP_MIN = 992;
	var DESKTOP_MAX = 1999;
	var LG_DESKTOP_MIN = 1200;
	/**
	 * @returns {boolean}
	 */

	function isXsMobile() {
	  return window.matchMedia("(max-width: ".concat(XS_MOBILE_MAX, "px)")).matches;
	}
	/**
	 * @returns {boolean}
	 */

	function isMobile() {
	  return window.matchMedia("(max-width: ".concat(MOBILE_MAX, "px)")).matches;
	}
	/**
	 * @returns {boolean}
	 */

	function isTablet() {
	  return window.matchMedia("(min-width: ".concat(TABLET_MIN, "px) and (max-width: ").concat(TABLET_MAX, "px)")).matches;
	}
	/**
	 * @returns {boolean}
	 */

	function isDesktop() {
	  return window.matchMedia("(min-width: ".concat(DESKTOP_MIN, "px)")).matches;
	}
	/**
	 * @returns {boolean}
	 */

	function isLargeDesktop() {
	  return window.matchMedia("(min-width: ".concat(LG_DESKTOP_MIN, "px)")).matches;
	}
	/**
	 * @returns {boolean}
	 */

	function notMobile() {
	  return window.matchMedia("(min-width: ".concat(TABLET_MIN, "px)")).matches;
	}
	/**
	 * @returns {boolean}
	 */

	function notTablet() {
	  return window.matchMedia("(max-width: ".concat(MOBILE_MAX, "px), (min-width: ").concat(DESKTOP_MIN, "px)")).matches;
	}
	/**
	 * @returns {boolean}
	 */

	function notDesktop() {
	  return window.matchMedia("(max-width: ".concat(TABLET_MAX, "px)")).matches;
	}
	/**
	 * @returns {boolean}
	 */

	function notLargeDesktop() {
	  return window.matchMedia("(max-width: ".concat(DESKTOP_MAX, "px)")).matches;
	}
	/**
	 * @returns {boolean}
	 */

	function isHighPixelDensity() {
	  return window.matchMedia('(-webkit-min-device-pixel-ratio: 2), (min-resolution: 192dpi)').matches;
	}

	var isEnum$1 = _objectPie.f;
	var _objectToArray = function (isEntries) {
	  return function (it) {
	    var O = _toIobject(it);
	    var keys = _objectKeys(O);
	    var length = keys.length;
	    var i = 0;
	    var result = [];
	    var key;
	    while (length > i) {
	      key = keys[i++];
	      if (!_descriptors || isEnum$1.call(O, key)) {
	        result.push(isEntries ? [key, O[key]] : O[key]);
	      }
	    }
	    return result;
	  };
	};

	// https://github.com/tc39/proposal-object-values-entries

	var $entries = _objectToArray(true);

	_export(_export.S, 'Object', {
	  entries: function entries(it) {
	    return $entries(it);
	  }
	});

	var entries = _core.Object.entries;

	var entries$1 = entries;

	var getAwarenessChannelOptions = function getAwarenessChannelOptions(state) {
	  return get_1(state, 'userAwareness.awarenessChannels', {});
	};
	var getAwarenessChannelOrder = function getAwarenessChannelOrder(state) {
	  return get_1(state, 'userAwareness.randomAwarenessChannelsOrder', []);
	};
	var getSelectedAwarenessChannelsList = function getSelectedAwarenessChannelsList(state) {
	  return entries$1(getAwarenessChannelOptions(state)).filter(function (_ref) {
	    var _ref2 = slicedToArray(_ref, 2),
	        value = _ref2[1];

	    return value;
	  }).map(function (_ref3) {
	    var _ref4 = slicedToArray(_ref3, 1),
	        key = _ref4[0];

	    return key;
	  });
	};

	var userAwarenessSelectors = /*#__PURE__*/Object.freeze({
		__proto__: null,
		getAwarenessChannelOptions: getAwarenessChannelOptions,
		getAwarenessChannelOrder: getAwarenessChannelOrder,
		getSelectedAwarenessChannelsList: getSelectedAwarenessChannelsList
	});

	// Action Types
	var ActionTypes = {
	  TOGGLE_CHANNEL_CHECKLED: 'zola/userAwareness/TOGGLE_CHANNEL_CHECKLED',
	  RESET_CHECKED_CHANNELS: 'zola/userAwareness/RESET_CHECKED_CHANNELS'
	}; // Actions

	var toggleChannelChecked = function toggleChannelChecked(channel, isChecked) {
	  return {
	    type: ActionTypes.TOGGLE_CHANNEL_CHECKLED,
	    payload: {
	      channel: channel,
	      isChecked: isChecked
	    }
	  };
	};
	var resetCheckedChannels = function resetCheckedChannels() {
	  return {
	    type: ActionTypes.RESET_CHECKED_CHANNELS
	  };
	};

	var userAwarenessActions = /*#__PURE__*/Object.freeze({
		__proto__: null,
		ActionTypes: ActionTypes,
		toggleChannelChecked: toggleChannelChecked,
		resetCheckedChannels: resetCheckedChannels
	});

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	  array || (array = Array(length));

	  while (++index < length) {
	    array[index] = source[index];
	  }

	  return array;
	}

	var _copyArray = copyArray;

	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeFloor = Math.floor,
	    nativeRandom = Math.random;
	/**
	 * The base implementation of `_.random` without support for returning
	 * floating-point numbers.
	 *
	 * @private
	 * @param {number} lower The lower bound.
	 * @param {number} upper The upper bound.
	 * @returns {number} Returns the random number.
	 */

	function baseRandom(lower, upper) {
	  return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	}

	var _baseRandom = baseRandom;

	/**
	 * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	 *
	 * @private
	 * @param {Array} array The array to shuffle.
	 * @param {number} [size=array.length] The size of `array`.
	 * @returns {Array} Returns `array`.
	 */

	function shuffleSelf(array, size) {
	  var index = -1,
	      length = array.length,
	      lastIndex = length - 1;
	  size = size === undefined ? length : size;

	  while (++index < size) {
	    var rand = _baseRandom(index, lastIndex),
	        value = array[rand];
	    array[rand] = array[index];
	    array[index] = value;
	  }

	  array.length = size;
	  return array;
	}

	var _shuffleSelf = shuffleSelf;

	/**
	 * A specialized version of `_.shuffle` for arrays.
	 *
	 * @private
	 * @param {Array} array The array to shuffle.
	 * @returns {Array} Returns the new shuffled array.
	 */

	function arrayShuffle(array) {
	  return _shuffleSelf(_copyArray(array));
	}

	var _arrayShuffle = arrayShuffle;

	/**
	 * The base implementation of `_.shuffle`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to shuffle.
	 * @returns {Array} Returns the new shuffled array.
	 */

	function baseShuffle(collection) {
	  return _shuffleSelf(values_1(collection));
	}

	var _baseShuffle = baseShuffle;

	/**
	 * Creates an array of shuffled values, using a version of the
	 * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to shuffle.
	 * @returns {Array} Returns the new shuffled array.
	 * @example
	 *
	 * _.shuffle([1, 2, 3, 4]);
	 * // => [4, 1, 3, 2]
	 */

	function shuffle(collection) {
	  var func = isArray_1(collection) ? _arrayShuffle : _baseShuffle;
	  return func(collection);
	}

	var shuffle_1 = shuffle;

	var channels = {
	  BOUGHT_GIFT: 'BOUGHT_GIFT',
	  // I bought a gift on Zola
	  FRIEND_FAMILY: 'FRIEND_FAMILY',
	  // Friend or Family
	  TV_COMMERCIAL: 'TV_COMMERCIAL',
	  // TV Commercial
	  PODCAST: 'PODCAST',
	  // Podcast
	  GOOGLE_SEARCH: 'GOOGLE_SEARCH',
	  // Google Search
	  WEDDING_BLOG: 'WEDDING_BLOG',
	  // Wedding blog or forum
	  FACEBOOK: 'FACEBOOK',
	  // Facebook
	  INSTAGRAM: 'INSTAGRAM',
	  // Instagram
	  PINTEREST: 'PINTEREST',
	  // Pinterest
	  SUBWAY: 'SUBWAY',
	  // Subway ad or billboard
	  PUBLICATION: 'PUBLICATION',
	  // News or article
	  OTHER: 'OTHER' // Any option not otherwise listed

	};

	function ownKeys$1(object, enumerableOnly) { var keys = keys$1(object); if (getOwnPropertySymbols$1) { var symbols = getOwnPropertySymbols$1(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return getOwnPropertyDescriptor$1(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

	function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(source, true).forEach(function (key) { defineProperty$3(target, key, source[key]); }); } else if (getOwnPropertyDescriptors$1) { defineProperties$1(target, getOwnPropertyDescriptors$1(source)); } else { ownKeys$1(source).forEach(function (key) { defineProperty$1(target, key, getOwnPropertyDescriptor$1(source, key)); }); } } return target; }

	var sortOtherLast = function sortOtherLast(first) {
	  if (first === channels.OTHER) return 1;
	  return -1;
	};

	var initialRandomAwarenessChannelsOrder = shuffle_1(keys$1(channels)).sort(sortOtherLast);

	var initialAwarenessChannels = keys$1(channels).reduce(function (acc, channel) {
	  acc[channel] = false;
	  return acc;
	}, {});

	var initialState = {
	  awarenessChannels: initialAwarenessChannels,
	  randomAwarenessChannelsOrder: initialRandomAwarenessChannelsOrder
	};

	var userAwarenessReducer = function userAwarenessReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments.length > 1 ? arguments[1] : undefined;

	  switch (action.type) {
	    case ActionTypes.TOGGLE_CHANNEL_CHECKLED:
	      return _objectSpread$1({}, state, {
	        awarenessChannels: _objectSpread$1({}, state.awarenessChannels, defineProperty$3({}, action.payload.channel, action.payload.isChecked))
	      });

	    case ActionTypes.RESET_CHECKED_CHANNELS:
	      return _objectSpread$1({}, state, {
	        awarenessChannels: initialState.awarenessChannels
	      });

	    default:
	      return state;
	  }
	};

	var toastConstants = {
	  POSITIVE: 'POSITIVE',
	  NEGATIVE: 'NEGATIVE'
	};

	/** @enum {string}  */

	var ActionTypes$1 = {
	  SHOW_TOAST: 'zola/toasts/SHOW_TOAST',
	  HIDE_TOAST: 'zola/toasts/HIDE_TOAST',
	  CLEAR_TOASTS: 'zola/toasts/CLEAR_TOASTS'
	};
	/** @typedef ToastOptions
	 * @property {string} [headline]
	 * @property {string} [dek] 
	 * @property {string} [type] 
	 * @property {number} [autoDismissInSeconds]
	 * @property {string} [dismissText]
	 * @property {function(): void} [onDismiss] 
	 * @property {string} [containerClass] 
	 * @property {string} [className]
	 */

	/** @type {ToastOptions} */

	var defaultToast = {
	  headline: null,
	  dek: null,
	  type: null,
	  autoDismissInSeconds: 3,
	  // seconds
	  dismissText: null,
	  onDismiss: null,
	  containerClass: null,
	  className: null
	};
	/** @typedef Payload
	 * @property {number} id
	 * @property {ActionTypes} type
	 */

	/** @typedef ToastAction
	 * @property {ActionTypes} type
	 * @property {Payload | number} [payload]
	 */

	/**
	 * @param {ToastOptions} opts
	 * @param {ActionTypes} type
	 * @returns {ToastAction}
	 */

	function show() {
	  var opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultToast;
	  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : toastConstants.POSITIVE;

	  var payload = assign$1({}, defaultToast, opts, {
	    id: new Date().valueOf(),
	    type: type
	  });

	  return {
	    type: ActionTypes$1.SHOW_TOAST,
	    payload: payload
	  };
	}
	/**
	 * @param {ToastOptions} opts
	 * @returns {ToastAction}
	 */

	function positive(opts) {
	  return show(opts, toastConstants.POSITIVE);
	}
	/**
	 * @param {ToastOptions} opts
	 * @returns {ToastAction}
	 */

	function negative(opts) {
	  return show(opts, toastConstants.NEGATIVE);
	}
	/**
	 * @param {number} id
	 * @returns {ToastAction}
	 */

	function hide(id) {
	  return {
	    type: ActionTypes$1.HIDE_TOAST,
	    payload: id
	  };
	}
	/**
	 * @returns {ToastAction}
	 */

	function clear() {
	  return {
	    type: ActionTypes$1.CLEAR_TOASTS
	  };
	}

	var toastsActions = /*#__PURE__*/Object.freeze({
		__proto__: null,
		ActionTypes: ActionTypes$1,
		show: show,
		positive: positive,
		negative: negative,
		hide: hide,
		clear: clear
	});

	function _arrayWithoutHoles(arr) {
	  if (isArray$1(arr)) {
	    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }

	    return arr2;
	  }
	}

	var arrayWithoutHoles = _arrayWithoutHoles;

	_export(_export.S + _export.F * !_iterDetect(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = _toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = core_getIteratorMethod(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = _ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && _isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        _createProperty(result, index, mapping ? _iterCall(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = _toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        _createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});

	var from_1 = _core.Array.from;

	var from_1$1 = from_1;

	function _iterableToArray(iter) {
	  if (isIterable$1(Object(iter)) || Object.prototype.toString.call(iter) === "[object Arguments]") return from_1$1(iter);
	}

	var iterableToArray = _iterableToArray;

	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance");
	}

	var nonIterableSpread = _nonIterableSpread;

	function _toConsumableArray(arr) {
	  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
	}

	var toConsumableArray = _toConsumableArray;

	var initialState$1 = [];

	var toastsReducer = function toastsReducer() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState$1;
	  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

	  switch (action.type) {
	    case ActionTypes$1.SHOW_TOAST:
	      return [].concat(toConsumableArray(state), [action.payload]);

	    case ActionTypes$1.HIDE_TOAST:
	      return state.filter(function (toast) {
	        return toast.id !== action.payload;
	      });

	    case ActionTypes$1.CLEAR_TOASTS:
	      return [];

	    default:
	      return state;
	  }
	};

	/** `Object#toString` result references. */

	var mapTag$3 = '[object Map]',
	    setTag$3 = '[object Set]';
	/** Used for built-in method references. */

	var objectProto$e = Object.prototype;
	/** Used to check objects for own properties. */

	var hasOwnProperty$c = objectProto$e.hasOwnProperty;
	/**
	 * Checks if `value` is an empty object, collection, map, or set.
	 *
	 * Objects are considered empty if they have no own enumerable string keyed
	 * properties.
	 *
	 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	 * jQuery-like collections are considered empty if they have a `length` of `0`.
	 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	 * @example
	 *
	 * _.isEmpty(null);
	 * // => true
	 *
	 * _.isEmpty(true);
	 * // => true
	 *
	 * _.isEmpty(1);
	 * // => true
	 *
	 * _.isEmpty([1, 2, 3]);
	 * // => false
	 *
	 * _.isEmpty({ 'a': 1 });
	 * // => false
	 */

	function isEmpty(value) {
	  if (value == null) {
	    return true;
	  }

	  if (isArrayLike_1(value) && (isArray_1(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer_1(value) || isTypedArray_1(value) || isArguments_1(value))) {
	    return !value.length;
	  }

	  var tag = _getTag(value);

	  if (tag == mapTag$3 || tag == setTag$3) {
	    return !value.size;
	  }

	  if (_isPrototype(value)) {
	    return !_baseKeys(value).length;
	  }

	  for (var key in value) {
	    if (hasOwnProperty$c.call(value, key)) {
	      return false;
	    }
	  }

	  return true;
	}

	var isEmpty_1 = isEmpty;

	// @ts-check
	/**
	 *
	 * @param {object} eventData Custom experiment viewed event data
	 * @param {string} eventData.vendor default is ZOLA, otherwise a predefined vendor (e.g. UNBOUNCE)
	 * @param {string} eventData.variationKey the name of the variation
	 * @param {string} eventData.experimentName the name of the experiment
	 */
	// Disable in case we add other experiment events.
	// eslint-disable-next-line import/prefer-default-export

	function trackCustomExperimentViewed(_ref) {
	  var _ref$vendor = _ref.vendor,
	      vendor = _ref$vendor === void 0 ? 'ZOLA' : _ref$vendor,
	      variationKey = _ref.variationKey,
	      experimentName = _ref.experimentName;
	  var eventData = {
	    vendor: vendor,
	    variation_name: variationKey,
	    experiment_name: experimentName
	  };
	  trackEvent('Custom Experiment Viewed', eventData);
	}

	var EXP_STORAGE_KEY = 'zola_user_experiments';
	var OVERRIDES_KEY = 'zola_flag_overrides';
	/**
	 * Enum for test values.
	 *
	 * @readonly
	 * @enum {string}
	 * @memberof client
	 */

	var experimentStates = {
	  NOT_IN_TEST: 'NOT_IN_TEST',
	  CONTROL: 'TEST-0'
	};
	/**
	 * @param {string} experimentName Experiment name
	 * @returns {boolean} indicating if the user has been placed in the experiment
	 * @memberof client
	 */

	function hasTriggeredExperiment(experimentName) {
	  var storedExperiments = getSessionStorage(EXP_STORAGE_KEY);
	  if (!storedExperiments) return false;
	  var parsed = JSON.parse(storedExperiments);
	  if (parsed) return Boolean(parsed[experimentName]);
	  return false;
	}
	/**
	 * Fires a Custom Experiment Viewed segment event and saves the experiment in session storage
	 *
	 * @param {string} experimentName Experiment name
	 * @param {string} variationKey Experiment variation
	 * @memberof client
	 * @returns {void}
	 */


	function triggerExperiment(experimentName, variationKey) {
	  if (variationKey !== experimentStates.NOT_IN_TEST) {
	    // @ts-ignore Argument of type '{ experimentName: string; variationKey: string; }' is not assignable to parameter of type '{ vendor: string; variationKey: string; experimentName: string; }'
	    trackCustomExperimentViewed({
	      experimentName: experimentName,
	      variationKey: variationKey
	    }); // Add to session storage

	    var triggeredExperiments = JSON.parse(getSessionStorage(EXP_STORAGE_KEY)) || {};
	    triggeredExperiments[experimentName] = true;
	    setSessionStorage(EXP_STORAGE_KEY, stringify$1(triggeredExperiments));
	  }
	}
	/**
	 * Fires a Custom Experiment Viewed segment event and saves the experiment in session storage
	 *
	 * @function getUserExperiments
	 * @param {string} experimentName Experiment name
	 * @param {object} userContext userContext for this user
	 * @returns {object} List of experiments for this user
	 * @memberof client
	 */


	function getUserExperiments(experimentName, userContext) {
	  return get_1(userContext, "user_experiments.".concat(experimentName), {});
	}
	/**
	 * @param {object} config User experiment config
	 * @param {string} config.experimentName The name of the experiment
	 * @param {object} config.userContext The latest user context
	 * @param {string} config.fallbackValue Default values for the experiment.
	 * @param {boolean} config.triggerExperimentViewed Do you want to trigger the experiment viewed event too?
	 * @returns {string} The experiment state for the user. Throws if the experiment is not present on the userContext and no fallbackConfig exists.
	 * @memberof client
	 */


	function getUserExperimentVariation(_ref) {
	  var experimentName = _ref.experimentName,
	      userContext = _ref.userContext,
	      fallbackValue = _ref.fallbackValue,
	      _ref$triggerExperimen = _ref.triggerExperimentViewed,
	      triggerExperimentViewed = _ref$triggerExperimen === void 0 ? false : _ref$triggerExperimen;
	  var experimentState = getUserExperiments(experimentName, userContext);
	  var variationKey = experimentState.variation_key;
	  var usingFallbackValue = false;

	  if (!variationKey) {
	    variationKey = fallbackValue;
	    usingFallbackValue = true;
	  }

	  var noStateError = new Error('No experiment state found, please ensure new experiments have a fallback config.');
	  if (!variationKey) throw noStateError; // Make sure a user context is present so we don't fire prematurely.

	  var userContextExists = !isEmpty_1(userContext);
	  var shouldTriggerExperiment = !usingFallbackValue && !hasTriggeredExperiment(experimentName) && triggerExperimentViewed && userContextExists;

	  if (shouldTriggerExperiment) {
	    triggerExperiment(experimentName, variationKey);
	  }

	  return variationKey;
	}
	/**
	 * Clear experiemnt storage
	 *
	 * @memberof client
	 */

	function clearExperimentStorage() {
	  deleteSessionStorage(EXP_STORAGE_KEY);
	}
	var getExperimentOverrides = function getExperimentOverrides() {
	  return JSON.parse(getSessionStorage(OVERRIDES_KEY)) || {};
	};
	var setExperimentOverrides = function setExperimentOverrides(experimentName, variation) {
	  if (!experimentName) return;
	  var flagOverrides = getExperimentOverrides();
	  flagOverrides[experimentName] = variation;
	  setSessionStorage(OVERRIDES_KEY, stringify$1(flagOverrides));
	};

	var getEnvironmentByHostname = function getEnvironmentByHostname() {
	  var hostname = window && window.location && window.location.hostname || '';

	  switch (hostname.toLowerCase()) {
	    // Commented out for now because it messes with tests
	    // case 'localhost':
	    //   return 'development';
	    case 'qa.zola.com':
	    case 'qa-homestore.zola.com':
	      return 'staging';

	    case 'www.zola.com':
	    case 'zola.com':
	    case 'homestore.zola.com':
	      return 'production';

	    default:
	      return 'production';
	  }
	};

	var getEnvironment = (function () {
	  var zolaEnv = window.zola && window.zola.env || getEnvironmentByHostname();

	  switch (zolaEnv) {
	    case 'development':
	    case 'dev':
	      return 'development';

	    case 'staging':
	    case 'stage':
	      return 'staging';

	    case 'production':
	    case 'prod':
	      return 'production';

	    default:
	      return 'production';
	  }
	});

	/**
	 * If experiment logic to be determined server-side, use server/src/experiments.js
	 */

	var NOT_IN_TEST = experimentStates.NOT_IN_TEST,
	    CONTROL = experimentStates.CONTROL;
	/** @typedef ExperimentFlags
	 * @property {string} development
	 * @property {string} staging
	 * @property {string} production
	 */

	/**
	 * makes the environment-based defaults for a flag
	 *
	 * @param {string} development
	 * @param {string} staging
	 * @param {string} production
	 * @returns {ExperimentFlags}
	 */

	var createExperimentFlags = function createExperimentFlags() {
	  var development = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : NOT_IN_TEST;
	  var staging = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : NOT_IN_TEST;
	  var production = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : NOT_IN_TEST;
	  return {
	    development: development,
	    staging: staging,
	    production: production
	  };
	};
	/** @typedef ExperimentFlagsType
	 * @property {function(string, object): boolean} getFlag
	 * @property {function(string, object, boolean): string} getExperimentVariation
	 * @property {function(string, object, boolean): boolean} isInExperiment
	 * @property {function(string, object, boolean): boolean} isControl
	 * @property {function(string, object, boolean): boolean} isUnderTest
	 */

	/**
	 * Given an list of fallback variations for the flag, provide functions for
	 * determining if a user is an experiment, in an A group, or in a B group.
	 *
	 * For simple A/B testing, where a user who is not in the test, is treated the
	 * same as the control, you will only need to use `isUnderTest`.
	 *
	 * @param {object.<string, string>} fallbackVariations
	 * @example - A/B testing with the control and not-in-test treated the same
	 *
	 * // in your web-app-specific helper, define the flags.
	 * // note, that if the default fallback for the flags are all NOT_IN_TEST, you can actually ommit
	 * // the FALLBACK_VARIATIONS
	 * // -- web-app/util/experimentFlags.js --
	 * const FALLBACK_VARIATIONS = {
	 * 'stanford-prison-experiment': experimentFlagsHelper.createExperimentFlags(NOT_IN_TEST, NOT_IN_TEST, NOT_IN_TEST),
	 * };
	 * export default experimentFlagsHelper.makeExperimentFlags(FALLBACK_VARIATIONS);
	 *
	 * // When you use the flags (in your web-app)
	 * import { isUnderTest } from '~/util/experimentFlags`;
	 * ...
	 * const isUnderTest = experimentFlags.isUnderTest('stanford-prison-experiment', userContext);
	 *
	 * if (isUnderTest) {
	 * ... user is in the B test (they are not control and they are in the experiment)
	 * } else {
	 * ... user is either the control or not in the test
	 * }
	 * @returns {ExperimentFlagsType}
	 */

	var makeExperimentFlags = function makeExperimentFlags(fallbackVariations) {
	  var getFallbackVariation = function getFallbackVariation(flagOrExperimentName) {
	    if (fallbackVariations[flagOrExperimentName]) {
	      return fallbackVariations[flagOrExperimentName][getEnvironment()];
	    }

	    return NOT_IN_TEST;
	  };
	  /**
	   * @param {string} experimentName
	   *
	   * returns override variation for a given experimentName, if set in localStorage
	   * returns undefined, if no override set
	   * @returns {ExperimentFlagsType | undefined}
	   *
	   * Note: never calls Custom Experiment Viewed event
	   */


	  var getOverrideVariation = function getOverrideVariation(experimentName) {
	    var flagOverrides = getExperimentOverrides();
	    return Object.prototype.hasOwnProperty.call(flagOverrides, experimentName) && flagOverrides[experimentName];
	  };
	  /**
	   * Returns the variation for the experiment / user / environment
	   *
	   * @param {string} experimentName
	   * @param {object} userContext
	   * @param {boolean} [triggerExperimentViewed=true]
	   *
	   * @example
	   * getExperimentVariation('WEAR_A_MASK', userContext) => 'NOT_IN_TEST' // the user is not participating in the test
	   * getExperimentVariation('WEAR_A_MASK', userContext) => 'TEST-0'      // the user is in the control group
	   * getExperimentVariation('WEAR_A_MASK', userContext) => 'TEST-1'      // the user is in the first test group
	   * getExperimentVariation('WEAR_A_MASK', userContext) => 'TEST-7'      // the user is in the seventh test group
	   *
	   * returns 'NOT_IN_TEST' if the user is not part of the experiment
	   * returns 'TEST-0' if the user is in the control group
	   * returns 'TEST-<N>' if the user is one of the test groups
	   * @returns {string}
	   */


	  var getExperimentVariation = function getExperimentVariation(experimentName, userContext) {
	    var triggerExperimentViewed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	    var fallbackValue = getFallbackVariation(experimentName);

	    if (getCookie('automatedTest')) {
	      return NOT_IN_TEST;
	    } // Return override only on dev & stage


	    var isProduction = getEnvironment() === 'production';
	    var overrideVariation = getOverrideVariation(experimentName);

	    if (!isProduction && overrideVariation) {
	      return overrideVariation;
	    }

	    return getUserExperimentVariation({
	      experimentName: experimentName,
	      userContext: userContext,
	      fallbackValue: fallbackValue,
	      triggerExperimentViewed: triggerExperimentViewed
	    });
	  };

	  var getFlag = function getFlag(experimentName, userContext) {
	    return getExperimentVariation(experimentName, userContext, false) !== NOT_IN_TEST;
	  };
	  /**
	   * Is the user in the experiement or not.  Being in the experiment you
	   * are either control or a variant.  The alternative is that you aren't under
	   * test.  If an experiement is setup as 100% in, 50% for control (a), 50% for
	   * varient (b) then everybody is in the A/B test (isInExperiment is always true)
	   *
	   * @param {string} experimentKey
	   * @param {object} userContext
	   * @param {boolean} [triggerExperimentViewed=true]
	   * @returns {boolean}
	   */


	  var isInExperiment = function isInExperiment(experimentKey, userContext) {
	    var triggerExperimentViewed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	    var experimentVariation = getExperimentVariation(experimentKey, userContext, triggerExperimentViewed);
	    return experimentVariation !== NOT_IN_TEST;
	  };
	  /**
	   * Is the user in the experiment and are they the control group
	   *
	   * @param {string} experimentKey
	   * @param {object} userContext
	   * @param {boolean} [triggerExperimentViewed=true]
	   * @returns {boolean}
	   */


	  var isControl = function isControl(experimentKey, userContext) {
	    var triggerExperimentViewed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	    return getExperimentVariation(experimentKey, userContext, triggerExperimentViewed) === CONTROL;
	  };
	  /**
	   * Is the in the experiment and are they _not_ the control group.
	   * If you have more than one variant (ie, and A/B/C test) instead
	   * of a single variant (classic A/B test) you will need to check
	   * the getExperimentVariation directly as you would have values such
	   * as NOT_IN_TEST, TEST-0, TEST-1, and TEST-2.
	   *
	   * @param {string} experimentKey
	   * @param {object} userContext
	   * @param {boolean} [triggerExperimentViewed=true]
	   * @returns {boolean}
	   */


	  var isUnderTest = function isUnderTest(experimentKey, userContext) {
	    var triggerExperimentViewed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	    var variant = getExperimentVariation(experimentKey, userContext, triggerExperimentViewed);
	    return variant !== CONTROL && variant !== NOT_IN_TEST;
	  };

	  return {
	    getFlag: getFlag,
	    getExperimentVariation: getExperimentVariation,
	    isInExperiment: isInExperiment,
	    isControl: isControl,
	    isUnderTest: isUnderTest
	  };
	};
	var experimentFlagsHelper = {
	  makeExperimentFlags: makeExperimentFlags,
	  createExperimentFlags: createExperimentFlags,
	  experimentStates: experimentStates
	};

	// @ts-check
	/**
	 * Generate the error ID
	 *
	 * @returns {string}
	 */

	var generateErrorId = function generateErrorId() {
	  return new Date().getTime().toString(32).toUpperCase();
	};
	/**
	 * Log an error message with the Zola logger in Admin
	 *
	 * @param {string} errorMessage General error message
	 * @param {object} payload Any additonal info to pass to the logger. Will accept any JSON object
	 * @returns {string}
	 */


	var log = function log(errorMessage, payload) {
	  var errorId = generateErrorId();
	  var errorMeta = {
	    id: errorId,
	    message: errorMessage
	  };
	  var body = {
	    meta: errorMeta,
	    data: payload
	  }; // Don't wait for the response since there's not much we can do if it fails

	  ApiService.post("/api/v0/log/".concat(errorId), body); // Return the error id to display for the user in case they contact CS

	  return errorId;
	};

	var logService = {
	  log: log
	};

	exports.ApiService = ApiService;
	exports.CTA_TYPES = CTA_TYPES;
	exports.DESKTOP_MAX = DESKTOP_MAX;
	exports.DESKTOP_MIN = DESKTOP_MIN;
	exports.LG_DESKTOP_MIN = LG_DESKTOP_MIN;
	exports.LogService = logService;
	exports.MOBILE_MAX = MOBILE_MAX;
	exports.STATUS_CODES = STATUS_CODES;
	exports.TABLET_MAX = TABLET_MAX;
	exports.TABLET_MIN = TABLET_MIN;
	exports.XS_MOBILE_MAX = XS_MOBILE_MAX;
	exports.camelize = camelize$1;
	exports.capitalizeAll = capitalizeAll$1;
	exports.capitalizeFirst = capitalizeFirst$1;
	exports.checkEmail = checkEmail;
	exports.checkResponse = checkResponse;
	exports.checkWAFErrors = checkWAFErrors;
	exports.clearExperimentStorage = clearExperimentStorage;
	exports.deleteAllStorage = deleteAllStorage;
	exports.deleteCookie = deleteCookie;
	exports.deleteLocalStorage = deleteLocalStorage;
	exports.deleteSessionStorage = deleteSessionStorage;
	exports.detectAndroid = detectAndroid;
	exports.detectIOS = detectIOS;
	exports.detectMobileDevice = detectMobileDevice;
	exports.detectTouchScreen = detectTouchScreen;
	exports.experimentFlagsHelper = experimentFlagsHelper;
	exports.experimentStates = experimentStates;
	exports.getAllStorage = getAllStorage;
	exports.getCookie = getCookie;
	exports.getDetailedMessage = getDetailedMessage;
	exports.getExperimentOverrides = getExperimentOverrides;
	exports.getLocalStorage = getLocalStorage;
	exports.getMobileOperatingSystem = getMobileOperatingSystem;
	exports.getQueryParam = getQueryParam;
	exports.getSessionStorage = getSessionStorage;
	exports.getUserExperimentVariation = getUserExperimentVariation;
	exports.insertInArrayIf = insertInArrayIf;
	exports.isDesktop = isDesktop;
	exports.isHighPixelDensity = isHighPixelDensity;
	exports.isLargeDesktop = isLargeDesktop;
	exports.isMobile = isMobile;
	exports.isTablet = isTablet;
	exports.isXsMobile = isXsMobile;
	exports.loadSrc = loadSrc;
	exports.loginFailure = loginFailure;
	exports.loginRequest = loginRequest;
	exports.loginSuccess = loginSuccess;
	exports.logout = logout;
	exports.notDesktop = notDesktop;
	exports.notLargeDesktop = notLargeDesktop;
	exports.notMobile = notMobile;
	exports.notTablet = notTablet;
	exports.onboardTrackingConstants = onboardTrackingConstants;
	exports.pascalize = pascalize$1;
	exports.pluralize = pluralize$1;
	exports.removeSubString = removeSubString$1;
	exports.renderIf = renderIf;
	exports.sendAppleLoginRequest = sendAppleLoginRequest;
	exports.sendFacebookLoginRequest = sendFacebookLoginRequest;
	exports.sendLoginRequest = sendLoginRequest;
	exports.sendResetPassword = sendResetPassword;
	exports.sendSignOutRequest = sendSignOutRequest;
	exports.sendSignupRequest = sendSignupRequest;
	exports.setAllStorage = setAllStorage;
	exports.setCookie = setCookie;
	exports.setExperimentOverrides = setExperimentOverrides;
	exports.setGTMLoggedIn = setGTMLoggedIn;
	exports.setGTMLoggedOut = setGTMLoggedOut;
	exports.setLocalStorage = setLocalStorage;
	exports.setSessionStorage = setSessionStorage;
	exports.toastsActions = toastsActions;
	exports.toastsConstants = toastConstants;
	exports.toastsReducer = toastsReducer;
	exports.trackCtaClicked = trackCtaClicked;
	exports.trackCtaViewed = trackCtaViewed;
	exports.trackEvent = trackEvent;
	exports.trackGoogleAnalyticsEvent = trackGoogleAnalyticsEvent;
	exports.trackMinimalLogoClick = trackMinimalLogoClick;
	exports.trackNavigationClicked = trackNavigationClicked;
	exports.trackOnboardingCompleted = trackOnboardingCompleted;
	exports.trackOnboardingStarted = trackOnboardingStarted;
	exports.trackOnboardingStepCompleted = trackOnboardingStepCompleted;
	exports.trackOnboardingStepSkipped = trackOnboardingStepSkipped;
	exports.trackOnboardingStepViewed = trackOnboardingStepViewed;
	exports.trackProductAdded = trackProductAdded;
	exports.truncate = truncate$1;
	exports.userAwarenessActions = userAwarenessActions;
	exports.userAwarenessChannelConstants = channels;
	exports.userAwarenessReducer = userAwarenessReducer;
	exports.userAwarenessSelectors = userAwarenessSelectors;

	Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=zola-helpers-client.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/@zola-helpers/client/dist/umd/zola-helpers-client.js
// module id = 16
// module chunks = 70